(function (factory) {
  // I'm a pre function
  factory();
} (function () {
    // I'm a factory getting executed
}));

angular.module('SumTotalComponents',['SumTotalComponents.Helpers','SumTotalAccordionModule','SumTotalActionGauge','SumTotalDatePicker','SumTotalDropdown','SumTotalClaw','SumTotalEllipsisModule','SumTotalNGEnterModule','SumTotalValidatedText','SumTotalLeftNav','SumTotalLiveRegion','SumTotalModalfilterModule','SumTotalNotificationTile','SumTotalPersonalization','SumTotalProgressBar','SumTotalSlideOutModule','SumTotalSectionModule','SumTotalSidePanel','SumTotalStarRating','SumTotalSumtProgressBar','SumTotalTabModule','SumTotalTimeline','SumTotalTooltipModule','SumTotalTypeahead','SumTotalWebpartModule','SumTotalWizard','ngTable','gridster','ngAnimate','mgcrea.ngStrap','multi-transclude','pascalprecht.translate','ui.tree','kcd']);
/* jshint strict:false  */

angular.module("SumTotalAccordionModule", [])
.directive('sumtaccordion', function () {
  return {
    templateUrl: 'accordion/accordion_view.html',
    controller: 'AccordionController',
    transclude: true,
    // link: function ($scope, $element, $attributes, controller) {
    link: function ($scope) {
      $scope.oneAtATime = true;
      $scope.groups = [];
      $scope.items = [];

      $scope.addItem = function () {
        var newItemNo = $scope.items.length + 1;
        $scope.items.push('Item ' + newItemNo);
      };
    }
  };
});

angular.module("SumTotalActionGauge", [])
.directive('actionGauge', function () {
	return {	
	 restrict: 'E',
      replace: false,
      transclude: true,
	  scope: {
        gaugeList: "=",
		outGaugeItem: "=",
		selectGaugeAction: "&"		
      },
      templateUrl: 'actionGauge/actionGaugeTemplate.html',
      link: function (scope, element, attrs) {
			scope.gaugeListItems = angular.copy(scope.gaugeList);
			scope.selectGauge = function (event, selectedItem) {
				angular.forEach(scope.gaugeListItems, function (item) {
				item.gaugeActive = false;
				});
				selectedItem.gaugeActive = true;
			    scope.outGaugeItem = selectedItem;
			    if (scope.selectGaugeAction) {
				  scope.selectGaugeAction({ $event: event, selectedGaugeItem: selectedItem });
			    }
			};	
		}
	}	
});
(function (root, factory) {
  'use strict';
  factory(root.angular)
}(this, function (angular) {
  'use strict';

  var clawModule = angular.module('SumTotalClaw', []);

  clawModule.directive('clawChart', ['$log', '$theme', function ($log, $theme) {
    return {
      restrict: 'EA',
      replace: false,
      transclude: true,
      templateUrl: 'claw/claw_view.html',
      link: function (scope, element, attrs, ctrl, transclude) { //jshint ignore:line
        scope.completedActivities = [];
        scope.tableDisplayContent = "";
        scope.ispreview = attrs.ispreview;
        scope.theme = $theme.theme;
        scope.container = element.parent()[0].offsetWidth;
        scope.autoDraw = attrs.autoDraw == 'false' ? false : true;
        scope.clawVisible = scope.autoDraw;
        scope.canvas = element.find("#clawCanvas");
        scope.transclusion = attrs.transclusion == 'true' ? true : false;
        scope.selectedChartViewType = 'chart';

        if (attrs.responsive == 'true')
          scope.chartWidth = element.parent()[0].offsetWidth - parseInt(element.parent().css('paddingLeft').replace('px', ''), 10) - parseInt(element.parent().css('paddingRight').replace('px', ''), 10);
        else
          scope.chartWidth = attrs.chartWidth;
        scope.canvas[0].style.cursor = 'pointer';
        var ctx = scope.canvas[0].getContext("2d");
        scope.elements = [];
        scope.arcs = [];
        scope.capabilities = [];
        scope.selectedGap;
        scope.categoryName;
        scope.selectedCapability;
        scope.cX = parseInt(attrs.clawWidth); //jshint ignore:line
        scope.canvas[0].width = scope.chartWidth - 45;
        scope.canvas[0].height = scope.cX + 8;
        var qtrC = 0.5 * Math.PI;
        var toolTip = element.find("#clawtip");
        var tipCtx = toolTip[0].getContext("2d");
        var curPerc = 0.5 * Math.PI;
        scope.radius = 0.3714 * Math.min(scope.cX, scope.cX);
        scope.inc = 30;
        scope.competencyWidth = parseInt(attrs.competencyWidth); //jshint ignore:line
        scope.gapRoom = scope.canvas[0].width - scope.cX - scope.competencyWidth;
        scope.labelStyle = scope.gapRoom - 10;
        scope.gapRoomPercent = (scope.gapRoom / scope.canvas[0].width) * 100;
        scope.legendWidth = element.find(".legendContainer").width();

        scope.ie_ver = function () {
          var iev = 0;
          var ieold = (/MSIE (\d+\.\d+);/.test(navigator.userAgent));
          var trident = !!navigator.userAgent.match(/Trident\/7.0/);
          var rv = navigator.userAgent.indexOf("rv:11.0");

          if (ieold) iev = new Number(RegExp.$1);
          if (navigator.appVersion.indexOf("MSIE 10") != -1) iev = 10;
          if (trident && rv != -1) iev = 11;

          scope.iev = iev;
        };

        scope.ie_ver();

        scope.canvasClick = function (e) {
          scope.tableDisplayContent = "";
          scope.completedActivities = [];
          scope.$apply(attrs.arcClick);

          var mouse = scope.getMousePos(scope.canvas, e);
          var x = mouse.x;
          var y = mouse.y;

          if (x > (scope.cX + scope.competencyWidth)) {
            $log.debug('Gap area clicked');
            angular.forEach(scope.elements, function (element) {
              if (y > element.y &&
                y < (element.y + element.height) &&
                x > element.x &&
                x < (element.x + element.width)) {

                $log.debug('Gap clicked:', element.name);

                scope.categoryName = element.name;
                scope.tableDisplayContent = "Gaps";
                scope.selectedGap = element.data;
                scope.selectedGap.categoryName = element.name;

                scope.$digest();
              }
            });
          } else if (x > scope.cX) {
            $log.debug('Capabilities area clicked.');

            angular.forEach(scope.capabilities, function (capability) {
              if (y > capability.y &&
                y < (capability.y + capability.height) &&
                x > (capability.x && x < capability.x + capability.width)) {
                // capability clicked!
                scope.tableDisplayContent = "Headers";
                scope.selectedCapability = capability.data;

                scope.$digest();
              }
            });
          } else if (x < scope.cX) {
            $log.debug('Job fit area was clicked. Checking arcs...');
            angular.forEach(scope.arcs, function (arc) {
              scope.defineArc(arc);
              if (scope.iev == 11) {
                if (ctx.isPointInPath(x, y)) {
                  scope.tableDisplayContent = arc.data.categoryKey;
                  scope.completedActivities = arc.data.completedActivities;
                  if (attrs && attrs.arcClick) {
                    scope.$apply(attrs.arcClick);
                  }
                } else {
                  $log.debug('Clicked point is not in path for arc. (' + x + ',' + y + ')');
                }
              } else {
                if (ctx.isPointInStroke(x, y)) {
                  scope.tableDisplayContent = arc.data.categoryKey;
                  scope.completedActivities = arc.data.completedActivities;
                  if (attrs && attrs.arcClick) {
                    scope.$apply(attrs.arcClick);
                  }
                } else {
                  $log.debug('Clicked point is not in stroke for arc. (' + x + ',' + y + ')');
                }
              }

              scope.$digest();
            });
          }
        };

        scope.getColor = function (color) {
          if (color == 'success')
            return scope.theme.configuration["@brand-success"];
          else if (color == 'warning')
            return scope.theme.configuration["@brand-warning"];
          else if (color == 'danger')
            return scope.theme.configuration["@brand-danger"];
          else if (color == 'info')
            return scope.theme.configuration["@brand-info"];
          else
            return color;
        };

        scope.clawBtnClick = function () {

        };

        scope.completedActivities = [{
            "name": "test",
            "acquiredProficiency": 30,
            "requiredProficiency": 23
          },
          {
            "name": "test",
            "acquiredProficiency": 30,
            "requiredProficiency": 23
          }
        ];

        scope.getMousePos = function (canvas, evt) {
          var rect = scope.canvas[0].getBoundingClientRect();
          return {
            x: evt.clientX - rect.left,
            y: evt.clientY - rect.top
          };
        };

        scope.canvasToolTip = function (e) {
          var hit = false;
          var mouse = scope.getMousePos(scope.canvas[0], e);
          var x = mouse.x;
          var y = mouse.y;
          var tipWidth, tipTxt;
          scope.elements.forEach(function (element) {
            if (y > element.y && y < element.y + element.height && x > element.x && x < element.x + element.width) {
              tipTxt = element.data.name;

              if (tipTxt.length > 80)
                tipTxt = tipTxt.substring(0, 77) + "...";

              tipWidth = tipCtx.measureText(tipTxt + " " + element.data.percent + "%").width + 10;

              if (x - (tipWidth / 2) < 0)
                toolTip[0].style.left = "10px";
              else if (x + (tipWidth / 2) > scope.canvas[0].width)
                toolTip[0].style.left = (scope.canvas[0].width - tipWidth) + "px";
              else
                toolTip[0].style.left = (x - (tipWidth / 2)) + "px";

              toolTip[0].style.top = (y - 17) + "px";
              toolTip[0].width = tipWidth;
              tipCtx.clearRect(0, 0, toolTip[0].width, toolTip[0].height);
              tipCtx.fillStyle = "#fff";
              tipCtx.font = "bold 12px Arial";
              tipCtx.fillText(tipTxt + " " + Math.round(element.data.percent * 10) / 10 + "%", 5, 15);
              hit = true;
            }
          });

          if (!hit)
            toolTip[0].style.left = "-3500px";
        };

        scope.canvas.click(scope.canvasClick);
        scope.canvas.mousemove(scope.canvasToolTip);

        scope.drawArc = function () {
          if (scope.data) {
            var radi = [],
              arcLength, textLength, txtAngle, labelTxt;
            for (var i = scope.data.length - 1; i >= 0; i--) {
              if (scope.data[i].percent > 100)
                scope.data[i].percent = 100;
              radi.push(scope.data[i].percent);
              arcLength = 2 * Math.PI * (scope.radius + (30 * i)) * (scope.data[i].percent / 360);
              textLength = ctx.measureText(scope.data[i].percent + "%");
              scope.arcRadians = scope.data[i].percent / 100 * qtrC + (qtrC);
              ctx.save();
              ctx.beginPath();
              ctx.lineWidth = 25;
              if (scope.data[i].color.indexOf('#') !== -1)
                ctx.strokeStyle = scope.data[i].color;
              else if (scope.data[i].color == 'success')
                ctx.strokeStyle = scope.theme.configuration["@brand-success"];
              else if (scope.data[i].color == 'warning')
                ctx.strokeStyle = scope.theme.configuration["@brand-warning"];
              else if (scope.data[i].color == 'danger')
                ctx.strokeStyle = scope.theme.configuration["@brand-danger"];
              else if (scope.data[i].color == 'info')
                ctx.strokeStyle = scope.theme.configuration["@brand-info"];
              ctx.arc(scope.cX, 1, scope.radius + (30 * i), 0.5 * Math.PI, scope.arcRadians, false);
              ctx.stroke();
              ctx.beginPath();
              ctx.arc(scope.cX, 1, scope.radius + (30 * i), scope.arcRadians, 1 * Math.PI, false);
              ctx.strokeStyle = "#eeeeee";
              ctx.stroke();

              ctx.save();
              if (textLength.width > arcLength) {
                txtAngle = (scope.data[i].percent + 60) / 100;
                ctx.fillStyle = "#4e5252";
              } else {
                txtAngle = scope.data[i].percent / 100;
                ctx.fillStyle = "#fff";
              }
              ctx.font = "bold 12px Arial";
              ctx.translate(scope.cX, 0);
              ctx.rotate(45 * Math.PI / 180 * txtAngle);
              ctx.fillText(scope.data[i].percent + "%", -12, scope.radius + (i * scope.inc) + 4);
              ctx.restore();

              scope.arcObject = {
                data: scope.data[i],
                cx: scope.cX,
                cy: 1,
                radius: scope.radius + (30 * i),
                start: 0.5 * Math.PI,
                end: scope.arcRadians
              };
              scope.arcs.push(scope.arcObject);
            }
            scope.inverseMin = 100 - Math.min.apply(null, radi);
          }
        };

        scope.defineArc = function (arc) {
          ctx.beginPath();
          ctx.arc(arc.cx, arc.cy, arc.radius, arc.start, arc.end);
        };

        scope.buildHeaders = function () {
          if (scope.data) {
            for (var i = scope.data.length - 1; i >= 0; i--) {
              ctx.save();
              ctx.beginPath();
              ctx.fillStyle = "#eeeeee";
              ctx.rect(scope.cX + 1, scope.radius + (i * scope.inc) - 11, scope.competencyWidth, 25);
              ctx.fill();
              ctx.fillStyle = "#4e5252";
              ctx.textAlign = "start";
              ctx.font = "bold 12px Arial";
              ctx.fillText("of", scope.cX + 5, scope.radius + (i * scope.inc) + 7);
              ctx.font = "bold 14px Arial";
              ctx.fillText(scope.data[i].id, scope.cX + 20, scope.radius + (i * scope.inc) + 7);

              scope.capabilityObject = {
                data: scope.data[i],
                x: scope.cX + 1,
                y: scope.radius + (i * scope.inc) - 11,
                width: scope.competencyWidth,
                height: 25
              };
              scope.capabilities.push(scope.capabilityObject);
            }
          }
        };

        scope.buildGaps = function () {
          if (scope.data) {
            for (var i = scope.data.length - 1; i >= 0; i--) {
              scope.barStart = scope.cX + scope.competencyWidth + 2;
              scope.barWidth = 0;
              scope.localGapRoom = scope.gapRoom - scope.data[i].items.length - 1;
              var txtLabel, txtLength, txtPercentLength, txtValLength;

              for (var j = 0; j < scope.data[i].items.length; j++) {
                ctx.beginPath();
                ctx.font = "12px Arial";
                ctx.textAlign = "center";
                if (scope.data[i].items[j].percent > 0)
                  scope.gapCount = scope.gapCount + 1;
                txtLabel = scope.data[i].items[j].name + " " + Math.round(scope.data[i].items[j].percent) + "%";
                txtLength = ctx.measureText(scope.data[i].items[j].name + " " + Math.round(scope.data[i].items[j].percent) + "%").width + 5;
                txtPercentLength = ctx.measureText(Math.round(scope.data[i].items[j].percent) + "%").width;
                txtValLength = ctx.measureText(Math.round(scope.data[i].items[j].percent)).width;
                scope.barStart = scope.barStart + scope.barWidth + 1;
                scope.barWidth = (scope.data[i].items[j].percent / scope.inverseMin) * scope.localGapRoom;
                if (scope.data[i].items[j].color != undefined) {
                  if (scope.data[i].items[j].color.indexOf('#') !== -1)
                    ctx.fillStyle = scope.data[i].color;
                  else if (scope.data[i].items[j].color == 'success')
                    ctx.fillStyle = scope.theme.configuration["@brand-success"];
                  else if (scope.data[i].items[j].color == 'warning')
                    ctx.fillStyle = scope.theme.configuration["@brand-warning"];
                  else if (scope.data[i].items[j].color == 'danger')
                    ctx.fillStyle = scope.theme.configuration["@brand-danger"];
                  else if (scope.data[i].items[j].color == 'info')
                    ctx.fillStyle = scope.theme.configuration["@brand-info"];
                }
                ctx.rect(scope.barStart, scope.radius + (i * scope.inc) - 11, scope.barWidth, 25);
                ctx.fill();
                ctx.fillStyle = "#ffffff";

                if (txtValLength > scope.barWidth) {
                  ctx.fillText("", scope.barWidth * 0.5 + scope.barStart, scope.radius + (i * scope.inc) + 6);
                } else if (txtPercentLength > scope.barWidth) {
                  ctx.fillText(Math.round(scope.data[i].items[j].percent), scope.barWidth * 0.5 + scope.barStart, scope.radius + (i * scope.inc) + 6);
                } else if (txtLength > scope.barWidth) {
                  ctx.fillText(Math.round(scope.data[i].items[j].percent) + "%", scope.barWidth * 0.5 + scope.barStart, scope.radius + (i * scope.inc) + 6);
                } else {
                  ctx.fillText(txtLabel, scope.barWidth * 0.5 + scope.barStart, scope.radius + (i * scope.inc) + 6);
                }

                scope.gapObject = {
                  data: scope.data[i].items[j],
                  name: scope.data[i].categoryKey,
                  x: scope.barStart,
                  y: scope.radius + (i * scope.inc) - 11,
                  width: scope.barWidth,
                  height: 25
                };
                scope.elements.push(scope.gapObject);
              }
              ctx.closePath();
            }
          }
        };

        scope.drawClaw = function () {
          scope.selectedGap = null;
          scope.selectedCapability = null;
          scope.completedActivities = null;
          scope.clawVisible = true;
          scope.gapCount = 0;
          // draw the background
          ctx.beginPath();
          ctx.save();
          ctx.translate(0.5, 0.5);
          scope.elements = [];
          scope.arcs = [];
          scope.capabilities = [];
          ctx.fillStyle = "#ffffff";
          ctx.fillRect(0, 0, scope.canvas[0].width, scope.canvas[0].height);
          ctx.strokeStyle = "#adadad";
          ctx.lineWidth = 1;
          ctx.moveTo(0, 0);
          ctx.lineTo(scope.canvas[0].width, 0);
          ctx.moveTo(0, scope.cX + 7);
          ctx.lineTo(scope.canvas[0].width, scope.cX + 7);
          ctx.moveTo(scope.cX + 0, 0);
          ctx.lineTo(scope.cX + 0, scope.cX + 7);
          ctx.moveTo(scope.cX + 2 + scope.competencyWidth, 0);
          ctx.lineTo(scope.cX + 2 + scope.competencyWidth, scope.cX + 7);
          ctx.moveTo(scope.cX, 0);
          ctx.lineTo(0, scope.cX);
          ctx.moveTo(scope.cX, 0);
          ctx.lineTo(0, scope.cX / 2);
          ctx.moveTo(scope.cX, 0);
          ctx.lineTo(scope.cX / 2, scope.cX);
          ctx.stroke();

          //build claw
          scope.buildHeaders();
          scope.drawArc();
          scope.buildGaps();
          ctx.restore();
        };

        $(window).resize(function () {
          if (scope.clawVisible) {
            scope.$apply(function () {
              scope.resize();
            });
          }
        });

        scope.resize = function () {
          if (!scope.clawVisible)
            scope.drawClaw();
          curPerc = 0.5 * Math.PI;
          if (attrs.responsive == 'true')
            scope.chartWidth = element.parent()[0].offsetWidth - 35;
          else
            scope.chartWidth = attrs.chartWidth;
          scope.canvas[0].width = scope.chartWidth - 45;
          scope.gapRoom = scope.canvas[0].width - scope.cX - scope.competencyWidth;
          scope.labelStyle = scope.gapRoom - 10;
          scope.gapRoomPercent = (scope.gapRoom / scope.canvas[0].width) * 100;
          scope.legendWidth = element.find(".legendContainer").width();
          scope.redraw();
        }

        scope.redraw = function () {
          ctx.clearRect(0, 0, scope.canvas[0].width, scope.canvas[0].height);
          scope.drawClaw();
        };

        scope.toggleChartViewType = function toggleChartViewType(evt) {

        };

        scope.$watch('data', function () {
          if (scope.autoDraw)
            scope.drawClaw();
        });

        scope.$watch('theme', function (newVal, oldVal) {
          if (scope.clawVisible)
            scope.resize();
        }, true);

        scope.$on('drawClaw', function () {
          scope.resize();
        });

        scope.$on('resizeClaw', function () {
          if (scope.clawVisible)
            scope.resize();
        });
      }
    };
  }]);

  clawModule.directive('clawChartBehaviorsList', [function () {
    return {
      templateUrl: 'claw/behaviors_list.html',
      scope: {
        displayFullText: "=",
        behaviors: "="
      },
      link: function (scope, element, attrs, ctrl, transclude) {}
    };
  }]);

  clawModule.directive('clawChartLearningList', [function () {
    return {
      templateUrl: 'claw/learning_list.html',
      scope: {
        displayFullText: "=",
        learningData: "="
      },
      link: function (scope, element, attrs, ctrl, transclude) {}
    };
  }]);

  clawModule.directive('clawChartSkillsList', [function () {
    return {
      templateUrl: 'claw/skills_list.html',
      scope: {
        displayFullText: "=",
        skills: "="
      },
      link: function (scope, element, attrs, ctrl, transclude) {}
    };
  }]);

  clawModule.directive('clawChartGapsList', ['$filter', '$translate', function ($filter, $translate) {
    return {
      templateUrl: 'claw/gap_info_list.html',
      scope: {
        items: "=",
        categoryName: "=",
        clawConfig: "=",
        displayFullText: "=",
        headerName: "=",
        filterComplete: "=",
        showDetails: "="
      },
      link: function (scope) {
        if (scope.filterComplete === true) {
          scope.items = $filter('filter')(scope.items, function(item){
            return item.percent > 0;
          });
        }
		 scope.activityActionBtnClick = function (action, activityId) {
          scope.$emit('actionEvents', {
            action: action,
            activityId: activityId
          });
        };

        if (scope.showDetails) {
          scope.$items = [];
          angular.forEach(scope.items, function (item,index) {
            if (item.items) {
              var newItem = Object.assign({}, item);
              scope.$items.push(Object.assign(newItem, item.items[0]));
            } else {
              scope.$items.push(item);
            }
			// Hiding the "AddToCart" and "shareWithCommunity" actions from action list
			 var actions = $filter('filter')(scope.$items[index].actions, function (item) { 
			 if (item.Key != "AddToCart" && item.Key != "shareWithCommunity")
                return item; 		
			 });
			 scope.$items[index].actions = actions;
			});
        } else {
			// added a check to hide addtocart and sharewithcommunity actions while clicking activity item on job fit. 
			if(scope.items.length == 1){
			 var actions = $filter('filter')(scope.items[0].actions, function (item) { 
			 if (item.Key != "AddToCart" && item.Key != "shareWithCommunity")
                return item; 		
			 });			
			scope.items[0].actions = actions;
			}
          scope.$items = scope.items;
        }

        if (scope.clawConfig && scope.clawConfig.legendColors && scope.clawConfig.legendColorLabels) {
          $translate(scope.clawConfig.legendColorLabels).then(function (translations) {
            var config = Object.assign.apply(null, scope.clawConfig.legendColors.map((function (e, i) {
              var tuple = {};
              tuple[e] = translations[scope.clawConfig.legendColorLabels[i]];
              return tuple;
            })));

            scope.$config = config;
          });
        }
      }
    };
  }]);
}));

angular.module('SumTotalDatePicker', ['mgcrea.ngStrap'])
  .directive('sumtDatepicker', ['$timeout', '$datepicker', '$dateFormatter', '$dateParser', '$filter', '$document', function ($timeout, $datepicker, $dateFormatter, $dateParser, $filter, $document) {
    'use strict';

    var openDatepickerPopup = null;
    var lastClickedDatepicker = null;
    var defaults = angular.extend({}, {
      dateFormat: 'shortDate',
      strictFormat: false,
      labelInput: null,
      id: null,
      placement: 'bottom-left',
      placeholder: null,
      container: 'body',
      labelNext: 'DATEPICKER_NEXT',
      labelPrevious: 'DATEPICKER_PREVIOUS',
      labelMonth: 'DATEPICKER_MONTHS',
      labelYear: 'DATEPICKER_YEARS',
      labelDays: 'DATEPICKER_DAYS',
      dateType: 'date',
      timezone: null,
      modelDateFormat: null,
      ariaLabelInput: null,
      showCultureFormat: null,
      },
      $datepicker.defaults);

    return {
      restrict: 'E',
      scope: {
        ngModelDate: '=ngModel',
        required: '=ngRequired',
        disabled: '=ngDisabled',
        readonly: '=ngReadonly',
        readonlyText: '=ngReadonlyText',
        onDateSelection: '&?'
      },
      require: ['ngModel', '?ngRequired', '?ngDisabled', '?ngReadonly', '?ngReadonlyText'],
      templateUrl: 'datepicker/datepicker.html',
      link: {
        pre: function preLink(scope, element, attr, controllers) {
          var ngModelController = controllers[0];

          var datePickerElement = element[0];
          var toggleButton = element.find('.calendar-toggle');

          // Add event listener to document to close datepicker popup when clicking outside
          $document.on('click', function (event) {
            var datepickers = document.querySelectorAll('.sumt-datepicker');
            datepickers.forEach(function (datepicker) {
              var popup = datepicker.querySelector('.dropdown-menu');
              if (popup && !datepicker.contains(event.target)) {
                datepicker.querySelector('.calendar-toggle').click();
              }
            });

          });

          // Add event listener to toggle button to open/close datepicker
          toggleButton.on('click', function (e) {
            var isSameButton = datePickerElement === openDatepickerPopup;

            var datepickers = document.querySelectorAll('.sumt-datepicker');
            datepickers.forEach(function (datepicker) {
              if (datepicker !== datePickerElement) {
                var popup = datepicker.querySelector('.dropdown-menu');
                if (popup) {
                  var toggle = datepicker.querySelector('.calendar-toggle');
                  toggle.click();
                }
              }
            });

            if (isSameButton && lastClickedDatepicker === openDatepickerPopup) {
              var popup = openDatepickerPopup.querySelector('.dropdown-menu');
              if (popup) {
                var toggle = openDatepickerPopup.querySelector('.calendar-toggle');
                toggle.click();
                e.stopPropagation();
                openDatepickerPopup = null;
                lastClickedDatepicker = null;
              }
            } else {
              openDatepickerPopup = datePickerElement;
              lastClickedDatepicker = datePickerElement;
            }
            scope.$apply();
          });

          var options = {
            scope: scope,
            lang: $dateFormatter.getDefaultLocale(),

          };

          angular.forEach([
              'dateFormat',
              'placement',
              'modelDateFormat',
              'strictFormat',
              'labelInput',
              'lang',
              'id',
              'placeholder',
              'container',
              'labelNext',
              'labelPrevious',
              'labelMonth',
              'labelYear',
              'labelDays',
              'timezone',
              'ariaLabelInput',
              'showCultureFormat',
            ],
            function (key) {
              if (angular.isDefined(attr[key])) options[key] = attr[key];
            });

          options = angular.extend({}, defaults, options);

          var dateParser = $dateParser({
            format: options.dateFormat,
            lang: options.lang,
            strict: options.strictFormat
          });

          if (angular.isDefined(attr.id)) {
            scope.inputId = attr.id + '_input';
			scope.alertSpanId = scope.inputId + '_span';
            scope.pickerId = attr.id + '_picker';
			scope.spanId = attr.id + '_span';
          } else if (attr.ngModel) {
            scope.inputId = attr.ngModel + '_input';
			scope.alertSpanId = scope.inputId + '_span';
            scope.pickerId = attr.ngModel + '_picker';
			scope.spanId = attr.ngModel + '_span';
          }

          if (angular.isDefined(attr.name)) {
            scope.inputName = attr.name;
          } else if (attr.ngModel) {
            scope.inputName = attr.ngModel + '_input';
          }

          if (options.dateFormat != "shortDate"){
            scope.dateFormat = options.dateFormat;
          }
          else{
            scope.dateFormat = dateParser.$format;
          }
          scope.showCultureFormat = options.showCultureFormat == "false" ? false : true;
          scope.placement = options.placement;
          scope.labelInput = attr.labelInput;
          scope.textboxPlaceholder = attr.placeholder;
          scope.container = attr.container || 'body';
          scope.ariaLabelInput = options.ariaLabelInput || $filter('translate')(scope.labelInput) + (scope.textboxPlaceholder ? ' (' + scope.textboxPlaceholder + ')' : '');

		  		  
          scope.labelNext = attr.labelNext || 'DATEPICKER_NEXT';
          scope.labelPrevious = attr.labelPrevious || 'DATEPICKER_PREVIOUS';
          scope.labelMonth = attr.labelMonth || 'DATEPICKER_MONTHS';
          scope.labelYear = attr.labelYear || 'DATEPICKER_YEARS';
          scope.labelDays = attr.labelDays || 'DATEPICKER_DAYS';

          scope.timezone = attr.timezone || options.timezone;
		  
		    if(scope.textboxPlaceholder){
          scope.placeholderdate = new Date();
		      scope.placeholderdateFormat = moment(scope.placeholderdate).format(scope.textboxPlaceholder.toUpperCase());
          }
          
          var btn = element.find('button');
          angular.forEach(['placement', 'container', 'delay'], function (key) {
            if (angular.isDefined(key)) {
              btn.attr(key, attr[key]);
            }
          });

          // Observe attributes for changes
          angular.forEach(['minDate', 'maxDate'], function (key) {
            if (angular.isDefined(attr[key])) {
              attr.$observe(key, function (newValue) {
                scope[key] = dateParser.getDateForAttribute(key, newValue);
              });
            }
          });
        },
	    post: function(scope,element,attr){
			scope.dateSelected= false;
			if (scope.onDateSelection && typeof (scope.onDateSelection) == 'function')
			{
				$("button").click(function(){
					scope.dateSelected = true;
				});
				$('input').on('keypress', function(e) {
					scope.dateSelected = true;
				});
			}
			
		  scope.$watch('ngModelDate', function(newValue, oldValue, element) {
			  scope.dateInvalid = "false";
              scope.inputBlur(element);
			  if (scope.onDateSelection && typeof (scope.onDateSelection) == 'function' && newValue!="" && (newValue!=oldValue) && scope.dateSelected)
			  {
				scope.onDateSelection();
				scope.dateSelected= false;
			  }
		  }); 		   

          var options = {
            scope: scope,
            lang: $dateFormatter.getDefaultLocale()
          };

          options = angular.extend({}, defaults, options);

          scope.dateParser = $dateParser({
            format: options.dateFormat,
            lang: options.lang,
            strict: options.strictFormat
          });
		  
		  scope.clearAlert = function(){
			$("#" + scope.alertSpanId).attr("role", "none");
			scope.dateInputAlert = "";
			scope.dateInvalid = "false";
		  };
		  
		  scope.setAlert = function(error){
			$("#" + scope.alertSpanId).attr("role", "alert");
			scope.dateInputAlert = error;
			scope.dateInvalid = "true";
		  }
		  
		  scope.dateInputAlert = "";
		  
		  scope.dateInvalid = "false";
     
		  scope.inputBlur = function(element){
			this.clearAlert();
			
			var minDate, maxDate = "";
			  
			if(scope.minDate && scope.minDate instanceof Date){
				minDate = scope.minDate.toDateString();
			}
			
			if(scope.maxDate && scope.maxDate instanceof Date){
				maxDate = scope.maxDate.toDateString();
			}
			
			scope.alertValuesObject = { 
				field_name : $filter('translate')(scope.labelInput), 
				format :$filter('uppercase')(scope.dateParser.$format), 
				minimum_date : minDate,
				maximum_date : maxDate
			}; 
			
			var dateString = $("#" + element.inputId).val();
			
			if(dateString == null || dateString == ""){
				return;
			}
			  
			var date = scope.dateParser.parse(dateString, null,  scope.dateFormat);
			
			if(!date){
				scope.setAlert("DATEPICKER_WRONG_FORMAT_ALERT");
			} else if(!(isNaN(scope.minDate)) && date.getTime() < scope.minDate){
				scope.setAlert("DATEPICKER_MINIMUM_ALERT");
			} else if(!(isNaN(scope.maxDate)) && date.getTime() > scope.maxDate){
				scope.setAlert("DATEPICKER_MAXIMUM_ALERT");
			}
		  };
	    }
      }
    };
  }]);

/* jshint strict:false  */

angular.module("SumTotalDropdown", [])
  .controller('dropDownCtrl', ['$scope', function ($scope) {
    $scope.dropdown = [
      {
        "text": "<i class=\"fa fa-download\"></i>&nbsp;Another action",
        "href": "#anotherAction"
              },
      {
        "text": "<i class=\"fa fa-globe\"></i>&nbsp;Display an alert",
        "click": "$alert(\"Holy guacamole!\")"
              },
      {
        "text": "<i class=\"fa fa-external-link\"></i>&nbsp;External link",
        "href": "/auth/facebook",
        "target": "_self"
              },
      {
        "divider": true
              },
      {
        "text": "Separated link",
        "href": "#separatedLink"
              }
            ];
    }]);

/* jshint strict:false  */
angular.module("SumTotalEllipsisModule", [])
  .directive('timelineellipsis', function () {
    return {
      restrict: 'A',
      replace: false,
      template: '<div class="sumt-ellipsis-container" ng-model="currentValue" title="">{{currentValue}}<div ng-hide="ellipsisExpanded" class="sumt-ellipsis-characters">...</div></div><div class="sumt-expand-container" ng-show="useClickExpand()"><a ng-click="handleClickEvent()" class="sumt-expand-collapse">{{buttonText}}<i ng-class="iconClass"></i></a></div>',
      link: function (scope, element, attrs) {
        scope.buttonText = attrs.expandText;
        scope.iconClass = attrs.expandIconClass;
        scope.showMore = false;
        scope.useClickExpand = function () {
          var retArgs = false;
          if (attrs.useClickExpand === "true" && scope.showMore) {
            retArgs = true;
          }
          return retArgs;
        };
        scope.originalText = '';
        scope.ellipsisText = '';
        scope.originalMaxHeight = '';
        scope.ellipsisExpanded = false;
        scope.containerElement = element.find('.sumt-ellipsis-container');
        //scope.buttonObj = element.find('.sumt-expand-collapse');
        scope.currentValue = '';
        scope.ellipsisElements = [];


        scope.handleClickEvent = function () {
          if (!scope.ellipsisExpanded) {
            //scope.currentValue = scope.originalText;
            scope.ellipsisExpanded = true;
            scope.originalMaxHeight = element.css("max-height");
            scope.containerElement.css("max-height", "none");
            scope.buttonText = attrs.collapseText;
            scope.iconClass = attrs.collapseIconClass;
            //element.find('.icon-downarrow-blue').addClass("icon-uparrow-blue");
            //element.find('.icon-downarrow-blue').removeClass("icon-downarrow-blue");
          } else if (scope.ellipsisExpanded) {
            //scope.currentValue = scope.ellipsisText;
            scope.ellipsisExpanded = false;
            scope.containerElement.css("max-height", "3.75em");
            scope.buttonText = attrs.expandText;
            scope.iconClass = attrs.expandIconClass;
            //element.find('.icon-uparrow-blue').addClass("icon-downarrow-blue");
            //element.find('.icon-uparrow-blue').removeClass("icon-uparrow-blue");
          }
        };

        if (!scope.ellipsisExpanded) {
          //if () {
          //if (scope.textCheck) {

          scope.currentValue = scope.$eval(attrs.descValue).expandableText;
          //scope.originalText = scope.$eval(attrs.descValue).expandableText;

          var tempElement = $(scope.containerElement).clone().insertBefore($(scope.containerElement));
          tempElement.css({
            position: "absolute",
            visibility: "hidden",
            zindex: "-1"
          });

          var width = parseInt(scope.containerElement[0].style.width ? scope.containerElement[0].style.width : (scope.containerElement.css("max-width") != "none" ? scope.containerElement.css("max-width") : scope.containerElement.css("width")), 10);
          var height = parseInt(scope.containerElement[0].style.height ? scope.containerElement[0].style.height : (scope.containerElement.css("max-height") != "none" ? scope.containerElement.css("max-height") : null), 10);
          var curText = scope.$eval(attrs.descValue).expandableText;

          tempElement.css({
            "width": height ? width + "px" : "",
            "max-width": "none",
            "height": "",
            "max-height": "none"
          });
          tempElement.text(curText);

          if ((height && tempElement.height() > height) || (!height && tempElement.width() > width)) {
            scope.showMore = true;
            //while (curText.length > 0 && ((height && tempElement.height() > height) || (!height && tempElement.width() > width))) {
            //	curText = curText.substring(0, curText.length - 1);
            //	tempElement.text(curText + "...");
            //	//console.log('got here - ' + test++);
            //}
            //scope.ellipsisText = tempElement.text();
            //scope.currentValue = tempElement.text();
          }
          tempElement.remove();
          //}
          //}
        }
        if (attrs.useAutoResize) {
          if (scope.ellipsisElements.length === 0) {
            $("#divMainContent").on("content-resize", function () {
              if ($SumtUI.EllipsisResizeTimeout)
                window.clearTimeout($SumtUI.EllipsisResizeTimeout);
              $SumtUI.EllipsisResizeTimeout = window.setTimeout(function () {
                for (var i = 0; i < $SumtUI.EllipsisElements.length; i++)
                  scope.applyEllipsis($SumtUI.EllipsisElements[i]);
              }, 100);
            });
          }
          scope.ellipsisElements.push(scope.containerElement);
        }
      }
    };
  });

angular.module("SumTotalNGEnterModule", [])
.directive('ngEnter', function () { //a directive to 'enter key press' in elements with the "ng-enter" attribute
   return function (scope, element, attrs) {
     element.on("keydown keypress", function (event) {
       if (event.which === 13) {
         scope.$apply(function () {
           scope.$eval(attrs.ngEnter);
         });

         event.preventDefault();
       }
     });
   };
});

/* jshint strict:false */
angular.module('SumTotalValidatedText', [])
  .directive('sumtValidatedText', function () {
    return {
      restrict: 'EA',
      //      require: ['ngModel', '^form'],
      //      require: '^form',
      replace: true,
      templateUrl: 'forms/text.html',
      scope: {
        validatedName: '@',
        validatedLabel: '&',
        controlData: '=',
        required: '@'
      },
      link: function (scope, element, attrs, controllers) {  // jshint ignore:line
        //scope._required = (scope.required === 'true') ? '' : 'required';
//        if (scope.required === 'true') {
//          element.find('input').attr('required', true);
//        }

        scope.getFormGroupClass = function (invalid, dirty, valid) {
          if (invalid && dirty) {
            return 'has-error';
          } else if (valid && dirty) {
            return 'has-success';
          } else {
            return '';
          }
        };
      }
    };
  });

// UMD / AMD:  https://github.com/umdjs/umd/blob/master/templates/amdWeb.js
(function (root, factory) {
  'use strict';

  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['angular'], factory);
  } else {
    // Browser globals
    factory(root.angular);
  }
}(this, function (angular) {
  'use strict';

  function MultiTransclude() {
    return {
      transclude: function (elem, transcludeFn, scope) {
        transcludeFn(function (clone) {
          angular.forEach(clone, function (cloneEl) {
            if (cloneEl.attributes) {
              var destinationId = cloneEl.attributes["transclude-to"].value;
              var destination = angular.element(elem[0].querySelector('[transclude-id="' + destinationId + '"]'));
              if (destination.length) {
                destination.append(cloneEl);
              } else {
                cloneEl.remove();
              }
            }
          });
        });
      }
    };
  }

  angular.module("SumTotalComponents.Helpers", [])
    .factory("MultiTransclude", [
      MultiTransclude
    ]);
}));

angular.module("SumTotalLeftNav", ['ngSanitize'])
  .directive('leftNavigation', ['$leftNavs', function ($leftNavs) {
    return {
      replace: false,
      restrict: 'A',
      templateUrl: 'leftnav/leftnav_view.html',
      transclude: true,
      scope: {
        header: '=',
        navData: '=',
        selectedNavData: '=',
        nodeClicked: '=',
        imageclicked: "&",
        persondata: "=",
        emulation: "=",
        exitemulation: "&",
		switchdomain:"=",
		translationobject:"="
      },
      link: function (scope, element, attrs) {
        scope.leftNavsProvider = $leftNavs;

        var key = attrs.name || attrs.id;
        key = key || 'defaultLeftNav';

        var contentTemplateUrl = angular.isDefined(attrs['contentTemplateUrl']) ? attrs['contentTemplateUrl'] : 'leftnav/leftnav_content_template_view.html';

        scope.asideScope = scope.$new();
        scope.asideScope.title = scope.header;
        scope.asideScope.show = false;

        scope.asideOptions = {
          title: scope.asideScope.title,
          backdrop: false,
          scope: scope.asideScope,
          templateUrl: contentTemplateUrl,
          html: true,
          placement: 'left',
          animation: 'am-slide-left',
          keyboard: false,
          show: scope.asideScope.show
        };
        scope.leftNavsProvider.addLeftNavigation(key, scope.asideOptions);

        scope.leftNavigationObject = scope.leftNavsProvider.getLeftNavigation(key);

        scope.navigateToAdmin = function (node, item) {
          scope.nodeClicked(node);
        }

        scope.close = function () {
          scope.leftNavsProvider.close(key);
        };

        scope.$watch('header', function (newVal) {
          scope.asideScope.title = newVal
        });

        scope.handleNodes = function (node, item) {

          item.toggle();
        }

        scope.handleNodeSelected = function (node, item) {

          if (node.RPKey == "Catalog") {

            scope.nodeClicked(node)
          } else {
            if (scope.nodeClicked && typeof scope.nodeClicked === 'function' && node.childNodes == null || node.childNodes.length == 0) {
              scope.nodeClicked(node);
            } else {
              item.toggle();
            }
          }

        };
      }
    };
  }]);

angular.module('SumTotalLeftNav')
  .provider('$leftNavs', function () {
    var _navigationsHash = {};
    var _currentKey = null;
    var _previousKey = null;

    var _addNavigation = function (key, leftNavAside) {
      var scopedObject = {
        isShown: false,
        showLimit: 3,
        toggleLimit: false,
        appended: false,
        onClose: null,
        leftNavAside: leftNavAside
      };

      if (!_navigationsHash[key]) {
        _navigationsHash[key] = scopedObject;
      }
    };

    function _closeCurrent() {
      if (_currentKey) {
        _navigationsHash[_currentKey].leftNavAside.hide();
        _navigationsHash[_currentKey].isShown = false;
        _previousKey = _currentKey;
      }
    };

    function _toggleNavigation(key, state) {
      switch (state) {
      case "open":
        _closeCurrent();
        if (_navigationsHash[key]) {
          _navigationsHash[key].leftNavAside.show();
          _navigationsHash[key].isShown = true;
          _currentKey = key; 
       // By default, setting focus on the lefyNav container.
        setTimeout(function () {
			var container = $('div.leftNav_container');
			if (container.length > 0)
              container[0].focus();
		  else
			 container.focus(); 
        },500);
        }
        break;
      case "close":
        if (_navigationsHash[key]) {
          _navigationsHash[key].leftNavAside.hide();
          _navigationsHash[key].isShown = false;
          _currentKey = null;
          _previousKey = null;
        }
        break;
      }
    };

    this.$get = ['$log', '$aside', '$injector', function ($log, $aside, $injector) {
      var navigationsHash = _navigationsHash;

      return {
        /**
         * Gets a left navigation object by its key.
         * @param   {string} key Unique key identifying the left navigation.
         * @returns {object} Object representing the left navigation.
         */
        getLeftNavigation: function (key) {
          $log.debug('Getting left navigation:', key);

          return navigationsHash[key];
        },
        /**
         * Adds a left navigtaion object.
         * @param {string} key          Unique key for the left navigation
         * @param {object} asideOptions Options hash.
         */
        addLeftNavigation: function (key, asideOptions) {
          _addNavigation(key, $aside(asideOptions));
        },
        /**
         *
         * @param key
         * @param onClose
         */
        open: function (key, onClose, targetSource) {
          if (onClose) {
            _navigationsHash[key].onClose = onClose;
          }

          //          var $slideout = $injector.get('$slideout');
          //          if ($slideout) {
          //            $slideout.close();
          //          }
          _toggleNavigation(key, "open");
		  if(targetSource)
		  {
			  _navigationsHash[key].targetSource=targetSource;
		  }		
        },
        /**
         * Closes a specific slideout. If no key is provided it will close the current.
         * @param {string} key Key identifier for the slideout. If none is provided it will clsoe the current slideout. BEWARE!
         */
        close: function (key) {
          this.isKeyboardEvent = false;
		  // This condition will work for chrome and IE browsers not for Firefox.
          if(typeof event !== 'undefined' && typeof event !== 'null') {
            if (event && (event.keyCode || event.which)) {
              this.isKeyboardEvent = true;
            }
			// This condition will work for Firefox browser.
          }else if(navigator.userAgent.indexOf("Firefox") > -1){
				  this.isKeyboardEvent = true;
			  }
          if (key && _navigationsHash && _navigationsHash[key]) {
            if (_navigationsHash[key].onClose) {
              var onCloseCallback = _navigationsHash[key].onClose;
              _navigationsHash[key].onClose = undefined;
              onCloseCallback();
            } else {
				if(_navigationsHash[key].isShown)
					_toggleNavigation(key, "close");
				else
					return;
            }
          } else if (!key && _currentKey) {
            this.close(_currentKey);
          }
		  if(_navigationsHash[key].targetSource && _navigationsHash[key].targetSource.currentTarget && this.isKeyboardEvent)
		  {
		  setTimeout(function () {
               angular.element($(_navigationsHash[key].targetSource.currentTarget)).trigger('focus');
              });
		  }
        },
        toggle: function (key) {
          if (!_navigationsHash[key]) return;

          if (_navigationsHash[key].isShown) {
            _toggleNavigation(key, "close");
          } else {
            _toggleNavigation(key, "open");
          }
        },
        /**
         *
         */
        getPreviousKey: function () {
          return _previousKey;
        }
      };
    }];
  });

angular.module("SumTotalLeftNav")
  .directive("selfheader", function () {
    return {
      replace: true,
      restrict: 'A',
      templateUrl: 'leftnav/self_header.html',
      scope: {
        imageclicked: '&',
        persondata: '=',
        emulation: "=",
        exitemulation: "&"
      },
      link: function (t, a, i) {}
    }
  });

angular.module('SumTotalLiveRegion', [])
  .provider('$sumtliveregion', function () {
    // Maybe put something here later?
    var options = this.options = {
      ariaLevel: "assertive",
      ariaRelevant: null,
      ariaAtomic: true,
      ariaLabeledBy: null,
      ariaDescribedBy: null
    }
    this.$get = function ($window, $rootScope, $timeout, $translate) {

      function LiveRegionFactory(element, controller, config) {
        var $sumtliveregion = {};
        var _queue = [];
        var _curMessage;
        var _translations;
        var _translationKeys = [
          'SORTING_TXT',
          'ASCENDING_TXT',
          'DESCENDING_TXT'
        ];

        $sumtliveregion.create = function (msg, config) {
          var message;
          message = angular.extend({
            msg: msg
          }, options, config);
          _queue.push(message);
          $sumtliveregion.queue = _queue;
          this.show();
        }

        $sumtliveregion.show = function () {
          if (_queue.length > 0) {
            _curMessage = _queue.length > 0 ? _queue[0] : null;
            _queue.splice(0, 1);
            // If queue still has items in it then handle by concatenating all of the messages together.  
            // NOTE: This should be a corner case and is not advised per TPG.
            if (_queue.length > 0) {
              // TODO: Loop through the queue and append into one single message   
            }
            $sumtliveregion.curMessage = _curMessage;
          }
        }

        $sumtliveregion.ngTableEvent = function (ngTableParams, config) {
          // Clear out the previous message for testing
          _curMessage = null;
          var msg;
          var sorting = ngTableParams.sorting();
          var orderBy = ngTableParams.orderBy();
          var filtering = ngTableParams.filter();
          var sortName = orderBy[0].slice(1);
          // If a caption is setup for a table it can be passed in (as right now there is no way in NG-Table to grab current table elements)
          var caption = ngTableParams.tableCaption ? ngTableParams.tableCaption : "";
          var sortDirection = sorting[sortName] == "asc" ? "ASCENDING_TXT" : "DESCENDING_TXT";
          var that = this;
          if (!_translations) {
            $translate(_translationKeys).then(function (translations) {
              _translations = translations;
              // Create a default message for NTTable sorting events
              msg = _translations['SORTING_TXT'] + " " + caption + " " + sortName + " " + _translations[sortDirection];
              that.create(msg, config);
            });
          } else {
            // Create a default message for NTTable sorting events
            msg = _translations['SORTING_TXT'] + " " + caption + " " + sortName + " " + _translations[sortDirection];
            this.create(msg, config);
          }
        }

        $sumtliveregion.showNext = function () {
          _curMessage = null;
          this.show();
        }

        return $sumtliveregion;
      }
      LiveRegionFactory.options = options;
      return new LiveRegionFactory;
    };

    this.$get.$inject = ['$window', '$rootScope', '$timeout', '$translate'];
  })
  .directive('sumtLiveRegion', ['$window', '$sumtliveregion', function ($window, $sumtliveregion) {
    return {
      restrict: 'EA',
      templateUrl: 'liveregion/liveregion_view.html',
      link: function (scope, element, attr) {
        scope.sumtliveregion = $sumtliveregion;
      }
    }
  }]);

/*
 Example use: <sumt-modalfilter data="activityData" title-all="{{titleAll}}" title-watch="{{titleWatch}}" tabpanel-id="modalFilterPanel" get-filter-field="getFilterField(activity)" after-filtering="afterFiltering()"></sumt-modalfilter>
parameters:
 data: Array of activities with ModalFilterValues as a field
 title-all: Translated title of All filter
 title-watch: Translated title of Watch filter
 title-read: Translated title of Read filter
 title-listen: Translated title of Listen filter
 tabpanel-id: tabpanel id of div that contains activity table
 getFilterField: Optional function that returns modal filter values
 afterFiltering: Optional function that executes after filtering data 
*/

(function (root, factory) {
    'use strict';

    factory(root.angular);
} (this, function (angular) {
    'use strict';

    angular.module("SumTotalModalfilterModule", [])
        .directive('sumtModalfilter', ['$filter', function ($filter) {
            return {
                restrict: 'E',
                replace: false,
                scope: {
                    data: "=",
                    titleAll: "@",
                    tabpanelId: "@",
                    getFilterField: "&?",
                    afterFiltering: "&?"
                },
                templateUrl: 'modalfilter/modalfilter_view.html',
                link: function (scope, element, attrs) {
                    scope.MODALFILTER_WATCH = 0;
                    scope.directiveId = scope.$id;
                    scope.currentlySelectedFilter = scope.MODALFILTER_ALL;
                    var isFiltered = false;

                    scope.$watch('data', function (newVal, oldVal) {
                        // When scope.data is updated outside of directive, update scope.unfiltered to be new data
                        if ((!isFiltered && scope.unfiltered != newVal) || (isFiltered && newVal != scope.filteredData)) {
                            scope.unfiltered = newVal;
                            showFilters();
                            if (scope.currentlySelectedFilter != scope.MODALFILTER_ALL) {
                                filterData();
                                if (scope.data.length == 0) {
                                    scope.currentlySelectedFilter = scope.MODALFILTER_ALL;
                                    scope.data = scope.unfiltered;
                                }
                            }
                        }
                    });

					/*
                        Retrieves the filter value from an activity
                        @param activity - The activity to obtain the filter values from
                        @returns - The bitwise value of modal filters
                    */
                    scope.getModalFilterValues = function (activity) {
                        if (scope.getFilterField && typeof (scope.getFilterField) == 'function')
                            return scope.getFilterField({ activity: activity });
                        else
                            return activity.ModalityList;
                    }
					
                    /*
                        Determines which filters should be shown for the control based on the provided data
                    */
					function showFilters() {
					   if (scope.unfiltered != null) {
						   var modalityIds = [];
						   scope.modalityList = [];
						   angular.forEach(scope.unfiltered, function (modalityData) {
								var modalityDataList = scope.getModalFilterValues(modalityData);
								angular.forEach(modalityDataList, function (modality) {
									var modalityId = modality.ModalityId;
									if (modalityIds.indexOf(modalityId) === -1) {
										modalityIds.push(modalityId);
										scope.modalityList.push(modality);
									}
								});
						   });
						}
					}

                    /*
                        Unfilters the data to show all items given.
                    */
                    function showAll() {
						isFiltered = false;
						scope.data = scope.unfiltered;
						scope.currentlySelectedFilter = scope.MODALFILTER_ALL;   
						if (scope.afterFiltering && typeof (scope.afterFiltering) == 'function')
                            scope.afterFiltering();
                    }

                    /*
                        Filters the data for a modality
                    */
                    scope.showCurrentFilter = function (modality) {
						scope.currentlySelectedFilter = modality.ModalityId;
						filterData();
					}


                    /*
                        Filters the data based on the currently selected filter
                    */
                    function filterData() {
						scope.filteredData = [];
						isFiltered = true;
						angular.forEach(scope.unfiltered, function (modalityData) {
							var filterExists = false;
							var modalityDataList = scope.getModalFilterValues(modalityData);
							angular.forEach(modalityDataList, function (modality) {
								if (modality.ModalityId === scope.currentlySelectedFilter) {
									filterExists = true;
								}
							});
							if (filterExists) {
								scope.filteredData.push(modalityData);
							}
						});
						scope.data = scope.filteredData;
						if (scope.afterFiltering && typeof (scope.afterFiltering) == 'function')
                            scope.afterFiltering();
                    }

                    /*
                        Handle moving the focus for left and right arrow keys
                    */
                    $(document).on("keydown.modalfilter" + scope.directiveId,
                        function (e) {
                            var className = ".move" + scope.directiveId;
                            var current = $(className + ":focus");
                            if (e.keyCode == 39) {
                                var next = current.next();
                                if (next.length == 0) {
                                    next = current.prevAll(className).last();
                                }
                                next.focus();
                            }
                            if (e.keyCode == 37) {
                                var previous = current.prev();
                                if (previous.length == 0) {
                                    previous = current.nextAll(className).last();
                                }
                                previous.focus();
                            }
                        }
                    );
					
					scope.$on('$destroy', function() {
                        $(document).off("keydown.modalfilter" + scope.directiveId);
                    });

                    element.on('$destroy', function () {
                        $(document).off("keydown.modalfilter" + scope.directiveId);
                    });

                    scope.$showAll = showAll;
                }
            };
        }]);
}));

/* jshint strict:false  */
angular.module('SumTotalNotificationTile', [])
  .directive('notificationTile',['$interval', function ($interval) {
    return {
      restrict: 'EA',
      replace: false,
      transclude: true,
      templateUrl: 'notificationTile/notificationTile_view.html',
      scope: {
        data: '='
      },
      link: function (scope, element, attrs) { //jshint ignore:line
        scope.pagination = attrs.pagination !== undefined ? attrs.pagination : 'false';
        scope.notifications = [];
        scope.selected = false;
        scope.pages = 0;
        scope.currentPage = 1;
        scope.timer = attrs.isTimed !== undefined && attrs.isTimed !== null ? attrs.isTimed : 'false';
        var interval;

        scope.startTimer = function(){
          interval = $interval(scope.paginate, scope.delay);
        }

        scope.getPages = function(){
          return new Array(scope.pages);
        }

        scope.setPage = function(idx){
          scope.currentPage = idx;
        }

        scope.getClass = function(item){
          return item.type;
        };

        scope.paginate = function(){
          if(scope.currentPage >= scope.pages)
            scope.currentPage = 1;
          else
            scope.currentPage += 1;
        }

        scope.addNotifSection = function (data) {
          scope.notifications.push(data);
          scope.pages++;
        };

        if (scope.data !== undefined) {
          angular.forEach(scope.data, function (item) {
            scope.addNotifSection(item);
          });
        }

        if(scope.timer === 'true' || attrs.delay !== undefined){
          scope.delay = scope.$eval(attrs.delay) !== undefined && scope.$eval(attrs.delay) !== null ? attrs.delay: 5000;
          scope.startTimer();
        }

        element.on('$destroy', function() {
          $interval.cancel(interval);
        });
      }
    };
  }]);

angular.module('SumTotalPersonalization', [])
  .provider('$theme', function () {
    /**
     * themeTemplate - Template of a theme from the server DTO.
     * currentTheme - variable to store reference to the current theme.
     */
    var themeTemplate = this.themeTemplate = {
        "ThemeKey": "DEFAULT",
        "Name": "Default Theme",
        "ClientJSON": {
          "colors": [
          "#ef4c00",
//            "#000",
          "#007bc3",
          "#a419b7",
          "#76b800",
          "#ffae00"
        ],
          "axisColor": "#5b5b5b",
          "gridColor": "#5b5b5b",
          "textColor": "#5b5b5b",
          "borderColor": "#ffffff",
          "backgroundColor": "#ffffff",
          "labelColor": "#5b5b5b",
          "@brand-primary": "darken(#428bca, 6.5%)",
          "@brand-success": "#1fbba6",
          "@brand-info": "#227AB9",
          "@brand-warning": "#ffc600",
          "@brand-danger": "#b80000",
          "@table-header-border-color": "#5b5b5b",
          "@gray-base": "#5b5b5b",
          "@table-border-color": "#5b5b5b"
        },
        "PaletteJSON": {
          "primary": "#077bc1",
          "palette": [
          "#0078c1",
          "#74b712",
          "#fead11",
          "#a41cb5",
          "#ee4b04",
          "#5c666f",
          "#e0e0df",
          "#ffffff"
        ]
        }
      },
      currentTheme = {},
      rootScope = null;

    /**
     * Sets the current theme in the provider.
     * @param   {Object}   theme ThemeDTO JSON object.
     */
    var setCurrentTheme = this.setCurrentTheme = function (theme) {
      theme = theme || themeTemplate;

      var clonedTheme = angular.copy(theme);
      currentTheme.key = clonedTheme.ThemeKey;
      currentTheme.name = clonedTheme.Name;
      currentTheme.configuration = clonedTheme.ClientJSON
      currentTheme.palette = clonedTheme.PaletteJSON;

      /**
       * Safe method to get a theme color
       * @param   {String} propertyName Color's name
       * @param   {String} defaultValue If the property cannot be found default to this color.
       * @returns {String} Color string
       */
      currentTheme.configuration.getColor = function (propertyName, defaultValue) {
        if (currentTheme.configuration && currentTheme.configuration[propertyName]) {
          return currentTheme.configuration[propertyName];
        } else {
          return defaultValue;
        }
      };

      if (rootScope) {
        rootScope.$broadcast('themeUpdated', currentTheme);
      }

    };

    this.$get = ['$log', '$rootScope', function ($log, $rootScope) {
      rootScope = $rootScope;

      if (!currentTheme || !currentTheme.key) {
        $log.debug('Theme not configured in app.config. Configuring now.');
        setCurrentTheme(themeTemplate)
      }
      return {
        "theme": currentTheme,
        "curTheme": currentTheme,
        "setCurrentTheme": setCurrentTheme
      };
    }];
  });

angular.module('SumTotalProgressBar', [])
  .directive('progressBar', ['$window', '$timeout','$filter','$rootScope', function ($window, $timeout, $filter,rootScope) {
	  
    return {
      restrict: 'EA',
      replace: false,
      transclude: true,
      templateUrl: 'progress-bar/progress-bar.html',
      scope: {
        completedCount: '=',
        ongoingCount: '=',
        pendingCount: '=',
        showPercent: '=',
        filterByStatusBar: '&?',
        instructionContent: '=?', //Taking translation key as input in form of a string and resolving the transalte value here
        additionalHeadingContent: '=?' //Taking additional content to display after the progress header text (use case in development plan landing page)
      },
      link: function (scope, element, attrs) {
		  
        
        
        scope.$watchCollection('[completedCount, ongoingCount, pendingCount]', function (newVal, oldVal) {
          if (newVal === oldVal) {
            $timeout(function () {
              setSeparators();
              setProgreessWidth();
            }, 700);
          } else {
            setSeparators();
            setProgreessWidth();
          }
          scope.completedTooltip = scope.completedCount == 0 || scope.completedCount == 1 ? $filter('translate')('UDP_NO_OF_TASK', { 'tasksCount': scope.completedCount }) : $filter('translate')('UDP_NO_OF_TASKS', { 'tasksCount': scope.completedCount });
          scope.ongoingTooltip = scope.ongoingCount == 0 || scope.ongoingCount == 1 ? $filter('translate')('UDP_NO_OF_TASK', { 'tasksCount': scope.ongoingCount }): $filter('translate')('UDP_NO_OF_TASKS', { 'tasksCount': scope.ongoingCount });
          scope.pendingTooltip = scope.pendingCount == 0 || scope.pendingCount == 1 ? $filter('translate')('UDP_NO_OF_TASK', { 'tasksCount': scope.pendingCount }) : $filter('translate')('UDP_NO_OF_TASKS', { 'tasksCount': scope.pendingCount });
        });

        var normalizeCount = function () {
          var normalizedCount = {};
          scope.totalCount = parseInt(scope.completedCount) + parseInt(scope.ongoingCount) + parseInt(scope.pendingCount);

          if (scope.totalCount === 0) {
            normalizedCount.completedCount = 0;
            normalizedCount.ongoingCount = 0;
            normalizedCount.pendingCount = 0;
          } else {
            normalizedCount.completedCount = (parseInt(scope.completedCount) / scope.totalCount);
            normalizedCount.ongoingCount = (parseInt(scope.ongoingCount) / scope.totalCount);
            normalizedCount.pendingCount = (parseInt(scope.pendingCount) / scope.totalCount);
          }
          return normalizedCount;
        }
		
		// this array will send to parent controller 
		
	scope.progressMetrics = {
        completedPercent: 0,
        ongoingPercent: 0,
        pendingPercent: 0
      }
        var setSeparators = function () {
          scope.completedNormalized = normalizeCount().completedCount;
          scope.ongoingNormalized = normalizeCount().ongoingCount;
          scope.pendingNormalized = normalizeCount().pendingCount;
          scope.completedPercent = 1 * parseFloat(scope.completedNormalized * 100).toFixed(0);
          scope.ongoingPercent = 1 * parseFloat(scope.ongoingNormalized * 100).toFixed(0);
          scope.pendingPercent = 1 * parseFloat(scope.pendingNormalized * 100).toFixed(0);
          var totalpercent = scope.completedPercent + scope.ongoingPercent + scope.pendingPercent;
          if (scope.totalCount !== 0) {

            if (totalpercent != 100) {
              if (totalpercent < 100) {
                var maxvalue = Math.max(scope.completedNormalized, scope.ongoingNormalized, scope.pendingNormalized);
                switch (maxvalue) {
                  case scope.completedNormalized:
                    scope.completedPercent += 1;
                    break;
                  case scope.ongoingNormalized:
                    scope.ongoingPercent += 1;
                    break;
                  case scope.pendingNormalized:
                    scope.pendingPercent += 1;
                    break;
                }
              } else if (totalpercent > 100) {
                var arrProgressVal = [scope.completedNormalized, scope.ongoingNormalized, scope.pendingNormalized];
                var minvalue = Math.min(scope.completedNormalized, scope.ongoingNormalized, scope.pendingNormalized);
                if (minvalue == 0) {
                  //if minimum val is 0 then remove it from the array and find second min val
                  arrProgressVal.splice(arrProgressVal.indexOf(minvalue), 1);
                  minvalue = Math.min.apply(null, arrProgressVal);
                }

                switch (minvalue) {
                  case scope.pendingNormalized:
                    scope.pendingPercent -= 1;
                    break;
                  case scope.ongoingNormalized:
                    scope.ongoingPercent -= 1;
                    break;
                  case scope.completedNormalized:
                    scope.completedPercent -= 1;
                    break;
                }
              }
            }
          }
		  //this data need for showing on print from development plan landing page
		  scope.progressMetrics.pendingPercent = scope.pendingPercent;
		  scope.progressMetrics.ongoingPercent = scope.ongoingPercent;
		  scope.progressMetrics.completedPercent = scope.completedPercent;
		  rootScope.$broadcast("progressMetrics", scope.progressMetrics);
        }
        var normalizeWidth = function (normalizationFactor) {
          return normalizationFactor * 100 + '%';
        }

        var setProgreessWidth = function () {
          $timeout(function () {
            $('.complete-width').css('width', normalizeWidth(normalizeCount().completedCount));
            $('.ongoing-width').css('width', normalizeWidth(normalizeCount().ongoingCount));
            $('.pending-width').css('width', normalizeWidth(normalizeCount().pendingCount));
          }, 100);
        }
		
		scope.hideEllipsis = function () {
        var contentHeight = $('.actual-instruction-content').css('height');
        if (contentHeight) {
          contentHeight = Number(contentHeight.replace(/[^0-9\.]+/g,""));// Converting to int for actual comparison
        }
        var parentHeight = $('.progress-instruction-container').css('height');
        if( parentHeight) {
          parentHeight = Number(parentHeight.replace(/[^0-9\.]+/g,""));// Converting to int for actual comparison
        }
        
        if (contentHeight <= parentHeight) { // If the content is not overflowing, need to cover up the ellipsis
          return 'progress-no-overflow';
        }
        return ''; // If the content is overflowing, we can show the ellipsis
		}
		
		 scope.statusBarFilter = function (taskStatus) {
          scope.taskStatus = taskStatus;
          scope.filterByStatusBar({ taskStatus: taskStatus });
        }
        scope.$on('resetStatusFilter', function () {
          scope.taskStatus = undefined;
        });

        $(window).resize(function () {
          $timeout(function () {
            setSeparators();
            setProgreessWidth();
          }, 100);
        });
      }
    };
  }]);

(function (root, factory) {
  'use strict';

  factory(root.angular);
}(this, function (angular) {
  'use strict';

  var KEY_CODES = {
    ENTER: 13,
    SPACE: 32
  };

  angular.module("SumTotalSectionModule", [])
    // The accordion directive simply sets up the directive controller
    // and adds an accordion CSS class to itself element.
    .directive('sumtSection', [function () {
      return {
        restrict: 'EA',
        transclude: true,
        replace: false,
        scope: {
          heading: '@',
          expandedIconClass: '@',
          collapsedIconClass: '@',
          appliedListElement: '@?',
          contextualClass: '@'
        },
        templateUrl: 'section/section_view.html',
        link: function (scope, element, attrs) {
          var allowedContextualClasses = ['primary', 'success', 'info', 'warning', 'danger'];

          if (angular.isDefined(attrs.id)) {
            scope.panelId = attrs.id + '_panel';
          }

          function changeState() {
            scope.isCollapsed = !scope.isCollapsed;
          }

          function handleClick() {
            changeState();
          }

          function handleKeyUp(evt) {
            if (evt.keyCode === KEY_CODES.ENTER || evt.keyCode === KEY_CODES.SPACE) {

              if (evt.preventDefault) evt.preventDefault();
              if (evt.stopPropagation) evt.stopPropagation();

              changeState();
            }
          }

          scope.isCollapsed = false;

          scope.$click = handleClick;
          scope.$keyUp = handleKeyUp;

          scope.heading = attrs.heading;
          scope.headerToggleOpen = scope.expandedIconClass !== undefined && scope.expandedIconClass !== '' ? scope.expandedIconClass : 'fa fa-caret-down';
          scope.headerToggleClosed = scope.collapsedIconClass !== undefined && scope.collapsedIconClass !== '' ? scope.collapsedIconClass : 'fa fa-caret-right';

          scope.setPanelClass = function () {
            var panelClass = 'panel',
              contextualClass = allowedContextualClasses.indexOf(scope.contextualClass) > -1 ? scope.contextualClass : 'primary';

            if (scope.contextualClass) {
              panelClass += ' ' + (contextualClass.indexOf('panel-') >= 0 ? contextualClass : ('panel-' + contextualClass));
            } else {
              panelClass += ' panel-default';
            }

            scope.panelClass = panelClass;
          };

          //setup the class
          scope.setPanelClass();
        }
      };
    }]);
}));

/* jshint strict:false  */
angular.module("SumTotalSidePanel", [])
.directive('sidepanel', function () {
  return {
    restrict: 'EA',
    replace: true,
    transclude: true,
    templateUrl: 'sidepanel/sidepanel_view.html',
    scope: {
      header: '@',
      panels: '&'
    },
    link: function (scope, element, attrs) { //jshint ignore:line

    }
  };
});

// UMD / AMD:  https://github.com/umdjs/umd/blob/master/templates/amdWeb.js
(function (root, factory) {
  'use strict';

  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['angular', 'lodash'], factory);
  } else {
    // Browser globals
    factory(root.angular, root._);
  }
}(this, function (angular) {
  'use strict';

  var MAIN_TEMPLATE_URL = 'slideout/slideout_view.html',
    ON_OPENING_EVENT_NAME = 'SLIDEOUT_ON_OPENING',
    ON_OPENED_EVENT_NAME = 'SLIDEOUT_ON_OPENED',
    ON_CLOSING_EVENT_NAME = 'SLIDEOUT_ON_CLOSING',
    ON_CLOSED_EVENT_NAME = 'SLIDEOUT_ON_CLOSED',
    ON_COLLAPSED_EVENT_NAME = 'SLIDEOUT_ON_COLLAPSED';

  function SlideoutOptions(options) {
    if (options !== undefined) {
      _.merge(this, options);
    }
  }

  SlideoutOptions.prototype = {
    showLeftSide: false,
    key: '',
    showCollapse: false,
    maintainFocus: true,
    focusElement: null,
    focusReturnElement: null,
    forceFocus: false,
    hasIframe: false,
    templateUrl: null,
    class: null,
    forceTemplateRecompile: false
  };


  function SlideoutOptionsFactory() {
    return SlideoutOptions;
  }

  function SlideoutFactory($slideout) {
    var defaults = $slideout.defaults;

    /**
     * Slideout representation. Contains options and state.
     *
     * The object also contains the template or tempalteUrl for the slideout. It defines the instance
     * options that are built from the base options through any specifics requested by the calling
     * implementation.
     * @param {HTMLElement} element
     * @param {any} config
     */
    function Slideout(element, config) {
      // Does this have a template url that defines the whole slideout template.
      // i.e. A templateUrl says that the slideout's layout will be completely defined by the template at the URL.
      config.hasTemplate = config.templateUrl !== null && config.templateUrl !== undefined && config.templateUrl.length > 0;


      this.$options = angular.extend(new SlideoutOptions(), defaults, config);

      // Ease of access variable
      this.key = this.$options.key;

      // Template for the slideout. This is usually populated from the 'slideout' directive and includes just an HTML string.
      this.element = element;
      // State - Is the slideout closed
      this.closed = this.$closed = true;
      // State - Is the slideout collapsed
      this.collapsed = this.$collapsed = false;
      // State - Is the slideout fully expanded.
      this.expand = this.$expand = false;
      // Is this a slideout that was instantiated from within a template of an opened slideout.
      this.isChildSlideout = false;
      // The child slideouts that were generated when a slideout's template was parsed.
      this.children = {};

      this.isCloseEnabled = true;
    }

    Slideout.prototype = {
      $handleKeyDown: function (event) {

      },
      /**
       * Placeholder function for legacy code.
       *
       * @deprecated Consumers should use the events "SLIDEOUT_ON_CLOSING" and "SLIDEOUT_ON_CLOSED" broadcasted from the service instead.
       */
      onClose: function () {},
      /**
       * Placeholder function for legacy code.
       *
       * @deprecated Consumers should use the events "SLIDEOUT_ON_OPENING" and "SLIDEOUT_ON_OPENED" broadcasted from the service instead.
       */
      onOpen: function () {},
      /**
       *
       */
      closeClicked: function () {}
    };

    return Slideout;
  }

  function SumTotalSlideoutProvider() {
    /**
     * Defines the defaults for any slideout.
     *
     * These are defined here both as an internal member and as on the actual provider. This makes it possible for an implementing
     * application to change these defaults for all slideouts.
     */
    var defaults = this.defaults = new SlideoutOptions();

     function focusSlideout(focusElement, fullopen) {
      //UI can provide the specific element it wants to focus on fullopen. By default, we will focus on the main slideout container
     if (focusElement === undefined || focusElement === null)
        focusElement = '.sumt-slideout';

      var container = $('div.master-slideout').find(focusElement);
      if (container.length > 0)
        setTimeout(function () {
          container[0].focus();
        }, 500);
      else {
        //assume we didn't find the element, probably first time open.  Allow the dom a second to update and try to grab it again
        if (focusElement === '.sumt-slideout') {
          setTimeout(function () {
            container = $('div.master-slideout').find(focusElement);
            if (container.length > 0)
              container[0].focus();
          }, 500);
        }
        else if (focusElement !== null && focusElement !== undefined) { 
          setTimeout(function () {
            angular.element(focusElement).trigger('focus');
          }, 500);
        }
      }
    }

    function handleMousedown() {
      // on a mouse click, remove the tab index attribute as we do not want to focus the container
      var slideoutDiv = $('.sumt-slideout');
      slideoutDiv.removeAttr("ng-attr-tabindex");
      slideoutDiv.removeAttr("tabindex");

      // handling one click is enough, we do not need to handle every mouse click. so turn it off
      slideoutDiv.off('mousedown', handleMousedown);
    }

    function handleKeyDown(event) {
      var elementsList = $('div.master-slideout :tabbable');

      var noOfElements = elementsList.length;
      if (event.keyCode == 9 && event.shiftKey === false) {
        if (event.target === elementsList[noOfElements - 1]) {

          event.preventDefault();

          // When the last element on the slideout is tabbed, do not focus on the slideout container - TPG recommendation
          // In some cases, the slideout container will not be in tabbable list at all. So first check if the first element is slideout container, then skip the tab on it
          if (elementsList[0].className.indexOf('sumt-slideout') > -1) {
            setTimeout(function () {
              elementsList[1].focus();
            });
          } else {
            elementsList[0].focus();
          }
        } else if (event.target.type == 'radio') {
          var nameAtt = event.target.getAttribute('name');
          if (elementsList[noOfElements - 1].type == 'radio' && elementsList[noOfElements - 1].getAttribute('name') == nameAtt) {
            event.preventDefault();
            elementsList[0].focus();
          }
        }
      } 
      // Shift+tab logic
      else if (event.keyCode == 9 && event.shiftKey == true) {
        if (event.target === elementsList[1]) {
          event.preventDefault();

          if (elementsList[0].className.indexOf('sumt-slideout') > -1) {
            setTimeout(function () {
              elementsList[noOfElements - 1].focus();
            });
          } else {
            elementsList[0].focus();
          }
        } else if(event.target === elementsList[0]) {
          event.preventDefault();
          elementsList[noOfElements - 1].focus();
        }

      }
    }

    function bindEvents(slideout) {
      if (slideout) {
        //get the slideout container
        var slideoutContainer = $('div.sumt-slideout');

        /* If there is an iframe on this slideout, then apend a hidden element to the container so that iframe
         * has an element to move focus to. That way focus will remain within the slideout. Otherwise, focus shits to address bar after iframe.
         * Make sure the hidden element is added only once as this method gets called multiple times. */

        if (slideout.$options.hasIframe && $('#idHiddenButton').length <= 0) {

          var hiddenButton = document.createElement("button");
          hiddenButton.id = "idHiddenButton";
          hiddenButton.setAttribute("style", "opacity: 0");
          hiddenButton.setAttribute("aria-hidden", "true");
          slideoutContainer[0].appendChild(hiddenButton);
        }
        $('.sumt-slideout').on('keydown', handleKeyDown);
        $('.sumt-slideout').on('mousedown', handleMousedown);
      }
    }

    function unbindEvents(slideout) {
      if (slideout && slideout.$options.maintainFocus) {
        $('.sumt-slideout').off('keydown', handleKeyDown);
      }
    }

    /**
     * A factory for creating a SumtotalSlideoutService constructor. (A factory for a factory, I suppose...)
     *
     * @param {any} $log
     * @param {any} $rootScope
     * @param {any} $templateRequest
     * @param {any} $timeout
     * @param {any} $q
     * @param {any} $compile
     */
    function SumTotalSlideoutServiceFactory($log, $rootScope, $templateRequest, $timeout, $q, $compile) {
      // These sections are defined in the default slideout template.
      var SECTIONS = {
        ALL_CONTENT: 'allcontent',
        HEADER: 'headersection',
        SIDE: 'sidecontent',
        EXPAND: 'expandcontent',
        FOOTER: 'footer'
      };

      /**
       * Slideout service.
       *
       * This service is defined as $slideout in the AngularJS module.
       */
      function SumTotalSlideoutService() {
        this.defaults = defaults;

        // State - Is the slideout view closed (not tracking an individual slideout but the view).
        this.closed = true;
        // The current Slideout object.
        this.currentSlideout = null;
        // The last opened slideout
        this.previousSlideout = null;
        // Hash of all the slideouts on the parent view.
        // NOTE - This will not include slideouts which are added from the compilation of a slideout's template.
        // Those slideouts will be defined on their parent's slideout 'children' property. That property is also a hash.
        this.slideouts = {};
        // Tracking all slideouts which have been opened since the last "close" was called. Used to clean up the view when "close" is actually called.
        this.openedSlideouts = [];
        // A slideout is pushed to the hiddenSlideouts when it is a slideout which was defined in the parent view and it in turn launches a slideout which was defined within its view.
        this.hiddenSlideouts = [];

        $rootScope.$on('$routeChangeStart', this._handleRouteChangeStart.bind(this));
      }

      // Grab the basic template for a slideout.
      var templateHTMLPromise = $templateRequest(MAIN_TEMPLATE_URL);

      /**
       * Load the basic slideout template along with either the template to be inserted into the slideout
       * or the HTML from the slideout directive's element.
       * @param {Slideout} slideout
       */
      function loadTemplates(slideout) {
        if (slideout.$options.templateUrl && slideout.$options.templateUrl.length > 0) {
          return $q.all([templateHTMLPromise, $templateRequest(slideout.$options.templateUrl)]);
        } else {
          return $q.all([templateHTMLPromise, $q.when(slideout.element)]);
        }
      }

      function getContainerClassFactory(scope, $slideout) {
        return function getContainerClass(slideout) {
          var retArgs = '';
          if (!$slideout.closed) {
            var previousKey = $slideout.previousSlideout && $slideout.previousSlideout.$options ? $slideout.previousSlideout.key : null;
            if (!previousKey && slideout && previousKey != slideout.key)
              retArgs += ' slideout-open';
            else
              retArgs += ' slideout-open-fade';
          } else {
            retArgs != 'slideout-closed';
          }
          if ($slideout.expand) {
            retArgs += ' slideout-fullopen';
          }
          if (slideout && slideout.$options.showCollapse && $slideout.collapsed) {
            retArgs += ' collapsed';
          }

          if (typeof (scope.$slideout.showHeader) != 'undefined' && !scope.$slideout.showHeader) {
            retArgs += ' slideout-displaytop';
          }
          return retArgs;
        };
      }

      SumTotalSlideoutService.prototype = {
        _handleRouteChangeStart: function routeChangeStartHandler() {
          $log.debug('Route is changing. Closing the slideout. This is default behavior defined in foundation.');
          this.closeCurrent();
        },
        /**
         *
         */
        $updateTemplate: function updateTemplate(slideout) {
          var htmlPromise = loadTemplates(slideout);

          return htmlPromise.then(function (results) {
            var elm = angular.element('div.master-slideout[key="' + slideout.key + '"]'),
              outerSlideoutElm = angular.element(results[0]),
              innerSlideoutElm = angular.element('<div></div>').html(results[1]);

            if (elm.length === 0) {
              $log.info('Creating a master-slideout container.');

              elm = angular.element('<div class="master-slideout ' +
                (slideout.$options.class ? slideout.$options.class : '') +
                '" key="' + slideout.key + '"></div>');

              $('body').append(elm);
            } else {
              $log.debug('Using the existing element for the slideout when updating the template. This is likely being done because the forceTemplateRecompile was set to true.');
            }

            if (slideout.$options.hasTemplate) {
              var innerSlideoutAllContentArea = innerSlideoutElm.find('div[name=' + SECTIONS.ALL_CONTENT + ']');

              if (innerSlideoutAllContentArea.length > 0) {
                outerSlideoutElm.find('div[name=' + SECTIONS.ALL_CONTENT + ']')
                  .replaceWith(innerSlideoutAllContentArea);
              } else {
                $log.warn('Current slideout doesn\'t have a div named "allcontent". Replacing with root.');

                outerSlideoutElm.find('div[name=' + SECTIONS.ALL_CONTENT + ']')
                  .replaceWith(innerSlideoutElm);
              }
            } else {
              /*
               * This case would be when a developer placed a slideout on a view and placed the view within the slideout.
               * The slideout directive will pass through the HTML (it also removes it from the DOM). We're placing the HTML
               * into the slideout to be compiled's HTML structure.
               */

              // Notice the use of replaceWith here. This is done so that we're not double inserting DIVs (it replaces the placeholder).
              outerSlideoutElm.find('div[name=' + SECTIONS.HEADER + ']')
                .replaceWith(innerSlideoutElm.find('div[name=' + SECTIONS.HEADER + ']'));

              outerSlideoutElm.find('div[name=' + SECTIONS.SIDE + ']')
                .replaceWith(innerSlideoutElm.find('div[name=' + SECTIONS.SIDE + ']'));

              outerSlideoutElm.find('div[name=' + SECTIONS.EXPAND + ']')
                .replaceWith(innerSlideoutElm.find('div[name=' + SECTIONS.EXPAND + ']'));
            }

            // place in the new html
            elm.html(outerSlideoutElm);


            function createScope() {
              /*
               * Create a child scope for the slideout to operate in. This way we can dispose of all the child scopes when the slideout closes.
               * The only time a slideout wouldn't have a scope associated on its $options object is when someone forgot to pass it in when
               * using the service to instantiate a new slideout.
               */
              if (slideout.$options && slideout.$options.scope) {
                return slideout.$options.scope.$new();
              } else {
                return $rootScope.$new();
              }
            }

            var slideoutScope = null;

            if (!slideout.isChildSlideout) {
              slideout.$scope = slideoutScope = createScope();

              slideoutScope.$slideout = this;
              slideoutScope.$getSlideoutContainerClass = getContainerClassFactory(slideoutScope, this);
            } else {
              slideoutScope = $rootScope.$new(false, slideout.$options.parentScope);

              slideoutScope.$slideout = this;
              slideoutScope.$getSlideoutContainerClass = getContainerClassFactory(slideoutScope, this);
            }

            slideoutScope.$$slideout = slideout;

            $compile(elm.contents())(slideoutScope);
          }.bind(this));
        },
        /**
         * Internal use to open a slideout object
         *
         * @param {Boolean} fullopen If the slideout should be opened fully
         * @param {Slideout} slideout The slideout object to show
         * @param {SlideoutOptions|undefined} options Supplemental options for per-call overrides of slideout options
         */
        $openSlideout: function openSlideout(fullopen, slideout, options) {
          /*
           * When open is called here are the following cases that we need to cover:
           * - No slideout has been opened; we're opening a slideout for the first time.      (CASE A)
           * - A slideout is currently opened (CASE B)
           *    - the key of the slideout we're opening is DIFFERENT from the current         (CASE B.a)
           *      - AND the new slideout was NOT declared in the current slideout's template  (CASE B.a.1)
           *      - AND the new slideout WAS declared in the current slideout's template      (CASE B.a.2)
           *    - the key of the slideout we're opening is the SAME as the current            (CASE B.b)
           *
           * CASE A is simple. Open the slideout
           *
           * CASE B:
           *
           *  CASE B.a: Opening a new slideout
           *
           *    CASE B.a.1:
           *      The new slideout is not a child of the first. The current slideout is closed and the new one opened.
           *
           *    CASE B.a.2
           *      The new slideout was declared in the current slideout's template. This means that it likely will want
           *      to access the scope of this slideout. We do not want to close and kill the current slideout. We want
           *      to "hide" it and open the slideout.
           *
           *  CASE B.b: Simply change the view from the fully opened view to the view where only the left side is visible.
           */

          // This is going to happen in any case so let's let everyone know we're about to open a slideout!
          $rootScope.$broadcast(ON_OPENING_EVENT_NAME, slideout);


          var openPromise = null;
          if (!this.currentSlideout) { // CASE A

            // update the properties on the slideout object AND the service
            this.collapsed = slideout.collapsed = slideout.$collapsed = false;
            this.closed = slideout.closed = slideout.$closed = false;
            this.expand = slideout.expand = slideout.$expand = fullopen;
            this.currentSlideout = slideout;

            openPromise = this.$updateTemplate(slideout).then(function () {
              //when slideout is partially open, then maintain focus based on the property sent by UI
              if (slideout.$options.maintainFocus) {
                bindEvents(slideout);
              }
            });
          } else if (this.currentSlideout.key !== slideout.key) { // CASE B.a
            $log.debug('Open Slideout - A slideout is opened (' +
              this.currentSlideout.key +
              ') a slideout is asking to be opened (' +
              slideout.key +
              ') fullopen: ' +
              fullopen.toString() +
              ' - slideout is the same as the current slideout:' +
              (this.currentSlideout === slideout).toString());

            if (this.currentSlideout.isChildSlideout) {
              // see if the slideout that is to be opened is in the stack of hidden slideouts.
              var parentSlideout = _.head(_.filter(this.hiddenSlideouts, {
                key: slideout.key
              }));

              if (parentSlideout) {
                // if the slideout to be opened IS in the hidden slideouts then we'll just close the current and reset the current to the hidden
                openPromise = this.closeCurrent().then(function () {
                  _.remove(this.hiddenSlideouts, {
                    key: parentSlideout.key
                  });
                });
              } else {

              }
            } else if (this.currentSlideout.children[slideout.key] === undefined) { // CASE B.a.1 - check to see if the slideout is in the current slideout's children hash.
              // close the currently opened slideout.
              openPromise = this.closeCurrent();
            } else { // CASE B.a.2
              // Do not close the currently opened slideout, hide it.
              // Note, doing this on the slideout and not the service.
              this.currentSlideout.collapsed = this.currentSlideout.$collapsed = false;
              this.currentSlideout.closed = this.currentSlideout.$closed = true;
              this.currentSlideout.expand = this.currentSlideout.$expand = fullopen;

              // Push the current slideout onto a hidden stack.
              this.hiddenSlideouts.push(this.currentSlideout);
            }

            // We have to set these variables in either case.
            this.collapsed = slideout.collapsed = slideout.$collapsed = false;
            this.closed = slideout.closed = slideout.$closed = false;
            this.expand = slideout.expand = slideout.$expand = fullopen;
            this.currentSlideout = slideout;

            var doUpdateTemplate = function () {
              return this.$updateTemplate(slideout).then(function () {
                //when slideout is partially open, then maintain focus based on the property sent by UI
                if (slideout.$options.maintainFocus) {
                  bindEvents(slideout);
                }
              });
            }.bind(this);

            if (openPromise) {
              openPromise.then(doUpdateTemplate);
            } else {
              // In either case we're going to open the slideout.
              openPromise = doUpdateTemplate();
            }
          } else { // CASE B.b
            $log.debug('CASE: Slideout is being requested to be opened is the same as the current slideout.');
            $log.debug('Open Slideout - A slideout is opened (' +
              this.currentSlideout.key +
              ') a slideout is asking to be opened (' +
              slideout.key +
              ') fullopen: ' +
              fullopen.toString() +
              ' - slideout is the same as the current slideout:' +
              (this.currentSlideout === slideout).toString());

            // update the properties on the slideout object AND the service
            this.collapsed = this.currentSlideout.collapsed = slideout.collapsed = this.currentSlideout.$collapsed = slideout.$collapsed = false;
            this.closed = this.currentSlideout.closed = slideout.closed = this.currentSlideout.$closed = slideout.$closed = false;
            this.expand = this.currentSlideout.expand = slideout.expand = this.currentSlideout.$expand = slideout.$expand = fullopen;
			this.currentSlideout.$options = slideout.$options;

            /// set custom focus element using key and id
            if(this.currentSlideout.$options.key == "WEB_PART_SLIDEOUT")
            {
              if(this.currentSlideout.$options.labelId == "widgetAdvancedEditHeading")
              {
                this.currentSlideout.$options.focusElement = "#advancedEdit"
              }         
            }

            if (options && options.forceTemplateRecompile) {
              // In either case we're going to open the slideout.
              openPromise = this.$updateTemplate(slideout).then(function () {
                //when slideout is partially open, then maintain focus based on the property sent by UI
                if (slideout.$options.maintainFocus) {
                  bindEvents(slideout);
                }
              });
            } else {
              // hand back a dummy promise since we're not opening anything.
              openPromise = $q.when();
            }
          }

          // When we're done doing the opening of the slideout focus it and broadcast that we've opened a slideout.
          return openPromise.then(function () {

            // focus on the slideout elements only when accessing it through keyboard events. do not focus
            // when opening through mouseclicks unless they want to enforce focus
           
              focusSlideout(slideout.$options.focusElement, fullopen);

            this.openedSlideouts.push(slideout);

            // tell the world that the slideout is now opened
            $rootScope.$broadcast(ON_OPENED_EVENT_NAME, slideout);

            $log.debug('Current state on open:', {
              service: {
                collapsed: this.collapsed,
                closed: this.closed,
                expand: this.expand
              },
              currentSlideout: {
                key: this.currentSlideout.key,
                collapsed: this.currentSlideout.$collapsed,
                closed: this.currentSlideout.$closed,
                expand: this.currentSlideout.$expand
              },
              slideoutObj: {
                key: slideout.key,
                collapsed: slideout.$collapsed,
                closed: slideout.$closed,
                expand: slideout.$expand
              }
            });
          }.bind(this));
        },
        /**
         *
         */
        $closeSlideout: function closeSlideout(slideout) {
          var openedSlideouts = [];
          _.forEach(this.openedSlideouts, function (openedSlideout) {
            openedSlideouts.push(openedSlideout.key);
          });

          this.openedSlideouts = [];

          if (slideout.$scope !== undefined && slideout.$scope !== null && typeof slideout.$scope.$destroy === 'function') {
            slideout.$scope.$destroy();
            slideout.$scope = null;
            delete slideout.$scope;
          }

          if (this.hiddenSlideouts && this.hiddenSlideouts.length > 0) {
            _.forEach(this.hiddenSlideouts, function (hiddenSlideout) {
              if (hiddenSlideout.$scope !== undefined && hiddenSlideout.$scope !== null && typeof hiddenSlideout.$scope.$destroy === 'function') {
                hiddenSlideout.$scope.$destroy();
                hiddenSlideout.$scope = null;
                delete hiddenSlideout.$scope;
              }
            });
          }

          this.hiddenSlideouts = [];

          return $q(function (resolve, reject) {
            // tried to use the transition end code and it wasn't firing. Odd.
            $rootScope.$applyAsync(function () {
              $timeout(function () {
                _.forEach(openedSlideouts, function (openedSlideout) {
                  var elm = angular.element('div[key="' + openedSlideout + '"]');
                  elm.remove();
                  resolve();
                });
              }, 250);
            });
          });
        },
        /**
         *
         */
        getCurrent: function () {
          return this.currentSlideout;
        },
        /**
         * Close the current slideout. This will remove the slideout from the DOM, any of its child slideouts will be removed as well.
         */
        closeCurrent: function closeCurrentSlideout(suppressEvents) {
          // current slideout, then be done.
          if (!this.currentSlideout) return $q.when();
          this.currentSlideout.isCloseEnabled = true;
          $log.debug('Closing the current slideout:', this.currentSlideout);

          if (suppressEvents !== true) {
            $rootScope.$broadcast(ON_CLOSING_EVENT_NAME, this.currentSlideout);
          }

          // Closing the current slideout means we're not showing any slideout set the state variables on the
          // slideout object AND the service.
          this.collapsed = this.currentSlideout.collapsed = this.currentSlideout.$collapsed = false;
          this.closed = this.currentSlideout.closed = this.currentSlideout.$closed = true;
          this.expand = this.currentSlideout.expand = this.currentSlideout.$expand = false;

          this.previousSlideout = this.currentSlideout;
          this.currentSlideout = null;

          if (this.previousSlideout.collapsible) {
            this.previousSlideout.$collapsed = false;
          }

          unbindEvents(this.previousSlideout);

          // Get the handle to the source element that triggered the slideout open
          var returnElementHandle = "";
		  try {
              returnElementHandle = $(this.sourceElementId);
            } catch (e) {
              returnElementHandle = '#layoutContainer';
          }		  
          // If UI passed in the focus return element specifically, use it
          if (this.previousSlideout.$options.focusReturnElement)
            returnElementHandle = $(this.previousSlideout.$options.focusReturnElement);
          
          return this.$closeSlideout(this.previousSlideout).then(function () {
            // Return focus to the source element
            if (returnElementHandle != null && returnElementHandle.length > 0)
            {
              $timeout(function () {
                returnElementHandle[0].focus();
              }, 250);
            }

            if (suppressEvents !== true) {
              if (this.previousSlideout && typeof this.previousSlideout.onClose === 'function') this.previousSlideout.onClose();
              $rootScope.$broadcast(ON_CLOSED_EVENT_NAME, this.previousSlideout);
            }
          }.bind(this));
        },
        maintainFocus: function () {

        },
        /**
         * Toggles a slideout's state.
         *
         * @param {Slideout} slideout
         * @param {String} state
         * @param {SlideoutOptions|undefined} options Supplemental options for per-call overrides of slideout options
         */
        toggleSlideout: function toggleSlideout(slideout, state, options) {
          switch (state) {
            // Open a slideout where just the left most portion is visible and on collapse of the expanded slide out
            case "open":
              $log.debug('Opening the slideout:', slideout.key);
              if (this.currentSlideout && !this.currentSlideout.isCloseEnabled) {
                  $rootScope.$broadcast(ON_COLLAPSED_EVENT_NAME, this.currentSlideout);
                  return;
              }
              this.$openSlideout(false, slideout, options);

              if (slideout && typeof slideout.onOpen === 'function') {
                slideout.onOpen.call(slideout);
              }
              break;

              // Close the slideout view; No slideouts will be open ( we don't stack slideouts)
            case "close":
              /*
               * Whenever close is called we're going to close the slideout view. That means that any slideouts, regardless of
               * if they were declared from the parent view or from within the current slideout's template must be cleaned up.
               */

              if (!this.currentSlideout) return;

              var slideoutToClose = this.currentSlideout;
              $rootScope.$broadcast(ON_CLOSING_EVENT_NAME, this.currentSlideout);
              this.closeCurrent(true);

              this.currentSlideout = null;
              this.previousSlideout = null;

              this.collapsed = slideoutToClose.collapsed = slideoutToClose.$collapsed = false;
              this.closed = slideoutToClose.closed = slideoutToClose.$closed = true;
              this.expand = slideoutToClose.expand = slideoutToClose.$expand = false;

              this.$closeSlideout(slideoutToClose);

              $rootScope.$broadcast(ON_CLOSED_EVENT_NAME, slideoutToClose);
              if (slideout && typeof slideout.onClose === 'function') {
                slideout.onClose.call(slideout);
              }
              break;

              // Make the slideout be fully opened.
            case "fullopen":
              $log.debug('Fully opening the slideout: ', slideout.key);

              this.$openSlideout(true, slideout, options);

              if (slideout && typeof slideout.onOpen === 'function') {
                slideout.onOpen.call(slideout);
              }
              break;
            case "collapse":
              $log.debug('Collapsing slideout:', slideout.key);
              if (!slideout.$options.maintainFocus) {
                unbindEvents(slideout);
              }

              this.collapsed = slideout.collapsed = slideout.$collapsed = true;
              this.closed = slideout.closed = slideout.$closed = true;
              this.expand = slideout.expand = slideout.$expand = false;

                $timeout(function () {
                  angular.element('#btnExpand').trigger('focus');
              }, 500);
          }
        },
        getSlideOut: function getSlideout(slideoutKey) {
          if (typeof slideoutKey === 'string') {
            var slideout = this.slideouts[slideoutKey];
            if (slideout === undefined && this.currentSlideout) {
              slideout = this.currentSlideout.children[slideoutKey];
            }
            return slideout;
          } else {
            return undefined;
          }
        },
        addSlideOut: function addSlideout(slideout) {
          if (typeof slideout === 'object' && slideout.$options && slideout.key !== undefined && slideout.key !== null) {
            // check to see if we're dealing with a child slideout
            if (slideout.isChildSlideout) { // if we're dealing with a child slideout then we'll add the slideout to the collection of its parent.
              this.currentSlideout.children[slideout.key] = slideout;
            } else {
              if (this.slideouts[slideout.key] !== undefined) {
                $log.warn('A slideout with the key ' + slideout.key + ' has already been added!');
              }

              this.slideouts[slideout.key] = slideout;
            }
          }
        },
        /**
         * Open a slideout. Can be invoked with the key of the slideout, the Slideout object,
         * or an adhoc object containing the basic slideout info.
         *
         * @param {String|Slideout|any} slideoutKey
         * @param {?} targetSource
         * @param {String} state
         * @param {SlideoutOptions|undefined} options Supplemental options for per-call overrides of slideout options
         */
        open: function openSlideout(slideoutKey, targetSource, state, options) {

          this.isKeyboardEvent = false;
          this.sourceElementId = '#layoutContainer';

          if(typeof event !== 'undefined' && typeof event !== 'null') {
            // check if it's a keypress event, there will be a valid keyCode
            if (event && event.keyCode) {
              this.isKeyboardEvent = true;
            }
            // Get the id of the element that triggered the slideout
            if (event.currentTarget && event.currentTarget.id)
              this.sourceElementId = '#' + event.currentTarget.id;
          }
          var slideout = null;
          if (typeof slideoutKey === 'string') {
            // opening a slideout by a registered key
            slideout = this.getSlideOut(slideoutKey);
          } else if (typeof slideoutKey === 'object' && slideoutKey.$options && slideoutKey.key) {
            //opening a slideout by a registered slideout object
            slideout = slideoutKey;
          } else if (typeof slideoutKey === 'object' && slideoutKey.$options === undefined) {
            // Opening a slideout in an adhoc fashion
            if (slideoutKey.key === undefined) return; // Can't open a slideout without a key.
            var Slideout = SlideoutFactory(this);

            slideout = new Slideout(undefined, slideoutKey);

            if (!slideout.$options.showLeftSide) {
              state = 'fullopen';
            }
          }

          if (!slideout) return;

          if (state === 'fullopen')
            slideout.$options.isPartialSlideout = false;
          else
            slideout.$options.isPartialSlideout = true;

          if (state === undefined) {
            // toggle slideout should focus the slideout when the 'open' state is used.
            this.toggleSlideout(slideout, 'open', options);
          } else {
            this.toggleSlideout(slideout, state, options);
          }
        },
        fullOpen: function openSlideoutFull(slideoutKey, options) {
          this.open(slideoutKey, undefined, 'fullopen', options);
        },
        close: function closeSlideout() {
          /*
            var mySlideout = $slideout.getSlideout('MY_SLIDEOUT_KEY');
            mySlideout.closeClicked = function () {
              if(iDontWantToClose) {
                return false;
              }
            };
            // or
            mySlideout.isCloseEnabled = false;
          */
          if (!this.currentSlideout) return;
          if (!this.currentSlideout.isCloseEnabled) {
            $rootScope.$broadcast(ON_CLOSING_EVENT_NAME, this.currentSlideout);
            return;
          }
          if (this.currentSlideout.closeClicked && typeof this.currentSlideout.closeClicked === 'function') {
            var dontPreventClose = true;
            try {
              dontPreventClose = this.currentSlideout.closeClicked();
            } catch (e) {
              $log.error('Error in the close click handler.', e);
            }

            if (dontPreventClose === false || dontPreventClose === undefined) this.toggleSlideout(undefined, 'close');
          } else {
            this.toggleSlideout(undefined, 'close');
          }
        },
        collapse: function collapseSlideout(slideoutKey) {
          $log.debug('Collapsing slideout.');
          var slideout = null;
          if (typeof slideoutKey === 'string') {
            slideout = this.slideouts[slideoutKey];
          } else if (typeof slideoutKey === 'object' && slideoutKey.$options && slideoutKey.key) {
            slideout = slideoutKey;
          }
          if (this.currentSlideout && !this.currentSlideout.isCloseEnabled) {
            $rootScope.$broadcast(ON_COLLAPSED_EVENT_NAME, this.currentSlideout);
            return;
          }
          this.toggleSlideout(slideout, 'collapse');
        },
		escapeSlideout: function escapeSlideout(keyEvent){
			if(keyEvent.keyCode == 27)
			this.close();
		}
      };

      SumTotalSlideoutService.prototype.getSlideout = SumTotalSlideoutService.prototype.getSlideOut;
      SumTotalSlideoutService.prototype.addSlideout = SumTotalSlideoutService.prototype.addSlideOut;

      /**
       *
       */
      SumTotalSlideoutService.prototype.EVENT_KEYS = SumTotalSlideoutService.EVENT_KEYS = {
        ON_OPENING_EVENT_NAME: ON_OPENING_EVENT_NAME,
        ON_OPENED_EVENT_NAME: ON_OPENED_EVENT_NAME,
        ON_CLOSING_EVENT_NAME: ON_CLOSING_EVENT_NAME,
        ON_CLOSED_EVENT_NAME: ON_CLOSED_EVENT_NAME,
        ON_COLLAPSED_EVENT_NAME: ON_COLLAPSED_EVENT_NAME
      };

      return new SumTotalSlideoutService();
    }

    // Deine the service getter. Assign the items that are being injected into the service factory function.
    this.$get = [
      '$log',
      '$rootScope',
      '$templateRequest',
      '$timeout',
      '$q',
      '$compile',
      SumTotalSlideoutServiceFactory
    ];
  }

  function SumTotalSlideout($log, Slideout, $slideout) {
    function slideoutCompile(element, attrs) {
      var slideout;

      // Directive options
      var options = {};
      angular.forEach(['labelId', 'templateUrl', 'key', 'focusElement', 'class', 'focusReturnElement', 'isConfigSlide'], function (key) {
        if (angular.isDefined(attrs[key])) options[key] = attrs[key];
      });

      // use string regex match boolean attr falsy values, leave truthy values be
      var falseValueRegExp = /^(false|0|)$/i;
      angular.forEach(['maintainFocus', 'showLeftSide', 'showCollapse', 'hasIframe', 'forceFocus'], function (key) {
        if (angular.isDefined(attrs[key])) {
          if (falseValueRegExp.test(attrs[key])) {
            options[key] = false;
          } else {
            options[key] = true;
          }
        }
      });

      if (attrs.focusElement !== undefined) delete attrs.focusElement;

      // Create a new Slideout object to track in the service.
      slideout = new Slideout(element.html(), options);

      slideout.isChildSlideout = $slideout.expand || !$slideout.closed;

      // Remove any content inside the directive's element. It we'll be placing that within the slideout template.
      element.children().remove();

      // Register the slideout with the provider
      $slideout.addSlideout(slideout);

      // Return the post link function.
      return slideoutPostLink;
    }

    /**
     *
     * @param {Scope} scope
     * @param {HTMLElement} element
     * @param {string[]} attrs
     */
    function slideoutPostLink(scope, element, attrs) {
      if (angular.isDefined(attrs.key)) {
        var slideout = $slideout.getSlideout(attrs.key);

        if (slideout) {
          slideout.$options.scope = scope;
          slideout.$options.parentScope = scope.$parent;
        }
      }
    }

    return {
      restrict: 'EA',
      compile: slideoutCompile,
    };
  }

  angular.module("SumTotalSlideOutModule", ['SumTotalComponents.Helpers'])
    .factory('slideoutOptionsFactory', SlideoutOptionsFactory)
    .factory('slideoutFactory', [
      '$slideout',
      SlideoutFactory
    ])
    .provider('$slideout', [
      SumTotalSlideoutProvider
    ])
    .directive('slideout', [
      '$log',
      'slideoutFactory',
      '$slideout',
      SumTotalSlideout
    ]);
}));

angular.module("SumTotalStarRating", [])
  .directive('starRating', function () {
    return {
      restrict: 'EA',
      replace: false,
      transclude: true,
      scope: {
        averageRatingValue: "@",
        userRatingValue: "@",
        colorValue: "@",
        fromSearch: "@",
		screenReader: "@",
		screenReaderValue:'@'
      },
      templateUrl: 'starRating/starRatingTemplate.html',
      link: function (scope, element, attrs) {
		if (angular.isUndefined(scope.fromSearch))
		{
			scope.fromSearch=false;
		}
		if (scope.screenReaderValue)
		{
			scope.screenreaderValue=scope.screenReaderValue;
		}
        scope.userRating = function () {
          if (scope.userRatingValue && scope.userRatingValue != '' && scope.userRatingValue != 0) {
            scope.ratingValue = scope.userRatingValue;
            var elements = angular.element(element).find('.star-yellow');
            for (var i = 0; i < Number(scope.userRatingValue); i++)
              angular.element(elements[i]).addClass("star-blue");
          }
        }
        scope.$watch('averageRatingValue', function () {
          scope.ratingValue = scope.averageRatingValue;
        });

        scope.averageRating = function () {
          if (scope.userRatingValue && scope.userRatingValue != '' && scope.userRatingValue != 0) {
            scope.ratingValue = scope.averageRatingValue;
            var elements = angular.element(element).find('.star-blue').removeClass("star-blue");
          }
        }
      }
    }

  });

/*
 Example use: <sumt-progress-bar percentcomplete="activity.percentComplete"></sumt-progress-bar>
parameters:
 percentcomplete: percentage value 0-100
 progressclass: used to change the color. ex: progress-bar-danger
 showInline: true or false - show the progress text inline or separately.
*/

angular.module("SumTotalSumtProgressBar", [])
  .directive('sumtProgressBar', function () {
    return {
      restrict: 'AE',
      replace: false,
      templateUrl: 'sumtprogressbar/sumtprogressbar.html',
      scope: {
        percentcomplete: '=',
        progressclass: '@',
        showInline: '='
      },
      link: function (scope, element, attrs) {

        scope.showProgessInline = function () {
          return (attrs.showInline === undefined) ? true : scope.showInline;
        }
      }
    }
  });

/* jshint strict:false  */
angular.module("SumTotalTabModule", [])
.controller('tabctrl', ["$scope", function ($scope) {
  $scope.tabs = [
      {
        "title": "Home",
        "content": "Dat raw denim you probably haven't heard of them jean shorts Austin. Nesciunt tofu stumptown aliqua, retro synth master cleanse. Mustache cliche tempor, williamsburg carles vegan helvetica."
      },
      {
        "title": "Profile",
        "content": "Food truck fixie locavore, accusamus mcsweeney's marfa nulla single-origin coffee squid. Exercitation +1 labore velit, blog sartorial PBR leggings next level wes anderson artisan four loko farm-to-table craft beer twee."
      },
      {
        "title": "About",
        "content": "Etsy mixtape wayfarers, ethical wes anderson tofu before they sold out mcsweeney's organic lomo retro fanny pack lo-fi farm-to-table readymade."
      },
      {
        "title": "Contact",
        "content": "Reprehenderit butcher retro keffiyeh dreamcatcher synth. Cosby sweater eu banh mi, qui irure terry richardson ex squid."
      }
    ];
}]);

/* jshint strict:false */
angular.module("SumTotalTimeline", [])
  .directive('sumtTimeline', ["$filter", function ($filter) {
      return {
        restrict: 'EA',
        transclude: true,
        scope: {
          data: '=',
          config: '=',
          hasFilter: '@',
          highlight: '@'
        },
        templateUrl: 'timeline/timeline_view.html',
        link: function (scope, element, attrs) { // jshint ignore:line
          scope.filter = attrs.hasFilter !== undefined && attrs.hasFilter === 'false' ? attrs.hasFilter : true;
          scope.nodes = [];
          scope.tabs = [];
          scope.selectedTab;
          scope.date = new Date();
          scope.compDate = $filter('date')(scope.date, "MM/dd/yyyy");
          scope.addDataNode = function (data) {
            scope.nodes.push(data);
          };

          scope.setConfig = function (config) {
            scope.tabs.push(config);
          };

          if (scope.config !== undefined) {
            angular.forEach(scope.config, function (item) {
              scope.setConfig(item);
            });
            scope.selectedTab = scope.tabs[0];
          }

          if (attrs.stagger !== undefined && attrs.stagger === 'false') {
            scope.stagger = false;
          } else {
            scope.stagger = true;
          }

          if (attrs.highlight !== undefined && attrs.highlight === 'false') {
            scope.highlight = false;
          } else {
            scope.highlight = true;
          }

          scope.setTabSelection = function(tab){
            scope.selectedTab = tab;
            scope.nodes = [];
            angular.forEach(scope.data, function (item) {
              if(item.type == tab.type || tab.type == 'all')
                scope.nodes.push(item);
            });
          }
        }
      };
    }
    ]);

/* jshint strict:false  */
angular.module("SumTotalTooltipModule", [])
.controller("toolTipControl", ["$scope", function ($scope) {
    $scope.dynamicTooltip = "Hello, World!";
    $scope.dynamicTooltipText = "dynamic";
    $scope.htmlTooltip = "I've been made <b>bold</b>!";
}]);

/* jshint strict:false */

angular.module('SumTotalTypeahead', ['mgcrea.ngStrap.tooltip', 'mgcrea.ngStrap.helpers.parseOptions'])

.provider('$sumttypeahead', function () {

  var defaults = this.defaults = {
    animation: 'am-fade',
    prefixClass: 'typeahead',
    prefixEvent: '$sumttypeahead',
    placement: 'bottom-left',
    template: 'typeahead/typeahead.tpl.html',
    trigger: 'focus',
    container: false,
    keyboard: true,
    html: false,
    delay: 0,
    minLength: 1,
    filter: 'filter',
    limit: 6,
    comparator: ''
  };

  this.$get = function ($window, $rootScope, $tooltip, $timeout) {

    function TypeaheadFactory(element, controller, config) {

      var $sumttypeahead = {};

      // Common vars
      var options = angular.extend({}, defaults, config);

      $sumttypeahead = $tooltip(element, options);
      var parentScope = config.scope;
      var scope = $sumttypeahead.$scope;

      scope.$resetMatches = function () {
        scope.$matches = [];
        scope.$activeIndex = -1;
      };
      scope.$resetMatches();

      scope.$activate = function (index) {
        scope.$$postDigest(function () {
          $sumttypeahead.activate(index);
        });
      };

      scope.$select = function (index) {
        scope.$$postDigest(function () {
          $sumttypeahead.select(index);
        });
      };

      scope.$isVisible = function () {
        return $sumttypeahead.$isVisible();
      };

      // Public methods

      $sumttypeahead.update = function (matches) {
        scope.$matches = matches;
        if (scope.$activeIndex >= matches.length) {
          scope.$activeIndex = -1;
        }
        return true;
      };

      $sumttypeahead.activate = function (index) {
        scope.$activeIndex = index;
      };

      $sumttypeahead.select = function (index) {
        var value = scope.$matches[index].value;
        // console.log('$setViewValue', value);
        controller.$setViewValue(value);
        controller.$render();
        scope.$resetMatches();
        if (parentScope) parentScope.$digest();
        // Emit event
        scope.$emit(options.prefixEvent + '.select', value, index, $sumttypeahead);
      };

      // Protected methods

      $sumttypeahead.$isVisible = function () {
        if (!options.minLength || !controller) {
          return !!scope.$matches.length;
        }
        // minLength support
        return scope.$matches.length && angular.isString(controller.$viewValue) && controller.$viewValue.length >= options.minLength;
      };

      $sumttypeahead.$getIndex = function (value) {
        var l = scope.$matches.length,
          i = l;
        if (!l) return;
        for (i = l; i--;) {
          if (scope.$matches[i].value === value) break;
        }
        if (i < 0) return;
        return i;
      };

      $sumttypeahead.$onMouseDown = function (evt) {
        // Prevent blur on mousedown
        evt.preventDefault();
        evt.stopPropagation();
      };

      $sumttypeahead.$onKeyDown = function (evt) {
        if (!/(38|40|13)/.test(evt.keyCode)) return;

        // Let ngSubmit pass if the typeahead tip is hidden
        if ($sumttypeahead.$isVisible() && evt.keyCode !== 13) {
          evt.preventDefault();
          evt.stopPropagation();
        }

        // Select with enter
        if (evt.keyCode === 13 && scope.$matches.length && scope.$activeIndex >= 0) {
          $sumttypeahead.select(scope.$activeIndex);
        } else if (evt.keyCode === 13 && scope.$matches.length && scope.$activeIndex >= 0) {
          return;
        } else if (evt.keyCode === 38 && scope.$activeIndex > 0) scope.$activeIndex--; // Navigate with keyboard
        else if (evt.keyCode === 40 && scope.$activeIndex < scope.$matches.length - 1) scope.$activeIndex++;
        else if (angular.isUndefined(scope.$activeIndex)) scope.$activeIndex = 0;
        scope.$digest();
      };

      // Overrides

      var show = $sumttypeahead.show;
      $sumttypeahead.show = function () {
        show();
        // use timeout to hookup the events to prevent
        // event bubbling from being processed imediately.
        $timeout(function () {
          $sumttypeahead.$element.on('mousedown', $sumttypeahead.$onMouseDown);
          if (options.keyboard) {
            element.on('keydown', $sumttypeahead.$onKeyDown);
          }
        }, 0, false);
      };

      var hide = $sumttypeahead.hide;
      $sumttypeahead.hide = function () {
        $sumttypeahead.$element.off('mousedown', $sumttypeahead.$onMouseDown);
        if (options.keyboard) {
          element.off('keydown', $sumttypeahead.$onKeyDown);
        }
        hide();
      };

      return $sumttypeahead;

    }

    TypeaheadFactory.defaults = defaults;
    return TypeaheadFactory;

  };

  this.$get.$inject = ['$window', '$rootScope', '$tooltip', '$timeout'];
})

.directive('sumtTypeahead', ['$window', '$parse', '$q', '$sumttypeahead', '$parseOptions',
                             function ($window, $parse, $q, $sumttypeahead, $parseOptions) {

    var defaults = $sumttypeahead.defaults;

    return {
      restrict: 'EAC',
      require: 'ngModel',
      link: function postLink(scope, element, attr, controller) {

        // Directive options
        var options = {
          scope: scope
        };
        angular.forEach(['placement', 'container', 'delay', 'trigger', 'keyboard', 'html', 'animation', 'template', 'filter', 'limit', 'minLength', 'watchOptions', 'selectMode', 'comparator', 'id'], function (key) {
          if (angular.isDefined(attr[key])) options[key] = attr[key];
        });

        // Build proper ngOptions
        var filter = options.filter || defaults.filter;
        var limit = options.limit || defaults.limit;
        var comparator = options.comparator || defaults.comparator;

        var ngOptions = attr.ngOptions;
        if (filter) ngOptions += ' | ' + filter + ':$viewValue';
        if (comparator) ngOptions += ':' + comparator;
        if (limit) ngOptions += ' | limitTo:' + limit;
        var parsedOptions = $parseOptions(ngOptions);

        // Initialize typeahead
        var typeahead = $sumttypeahead(element, controller, options);

        // Watch options on demand
        if (options.watchOptions) {
          // Watch ngOptions values before filtering for changes, drop function calls
          var watchedOptions = parsedOptions.$match[7].replace(/\|.+/, '').replace(/\(.*\)/g, '').trim();
          scope.$watch(watchedOptions, function () {
            // console.warn('scope.$watch(%s)', watchedOptions, newValue, oldValue);
            parsedOptions.valuesFn(scope, controller).then(function (values) {
              typeahead.update(values);
              controller.$render();
            });
          }, true);
        }

        // Watch model for changes
        scope.$watch(attr.ngModel, function (newValue) {
          // console.warn('$watch', element.attr('ng-model'), newValue);
          scope.$modelValue = newValue; // Publish modelValue on scope for custom templates
          parsedOptions.valuesFn(scope, controller)
            .then(function (values) {
              // Prevent input with no future prospect if selectMode is truthy
              // @TODO test selectMode
              if (options.selectMode && !values.length && newValue.length > 0) {
                controller.$setViewValue(controller.$viewValue.substring(0, controller.$viewValue.length - 1));
                return;
              }
              if (values.length > limit) values = values.slice(0, limit);
              var isVisible = typeahead.$isVisible();
              isVisible && typeahead.update(values);
              // Do not re-queue an update if a correct value has been selected
              if (values.length === 1 && values[0].value === newValue) return;
              !isVisible && typeahead.update(values);
              // Queue a new rendering that will leverage collection loading
              controller.$render();
            });
        });

        // modelValue -> $formatters -> viewValue
        controller.$formatters.push(function (modelValue) {
          // console.warn('$formatter("%s"): modelValue=%o (%o)', element.attr('ng-model'), modelValue, typeof modelValue);
          var displayValue = parsedOptions.displayValue(modelValue);
          return displayValue === undefined ? '' : displayValue;
        });

        // Model rendering in view
        controller.$render = function () {
          // console.warn('$render', element.attr('ng-model'), 'controller.$modelValue', typeof controller.$modelValue, controller.$modelValue, 'controller.$viewValue', typeof controller.$viewValue, controller.$viewValue);
          if (controller.$isEmpty(controller.$viewValue)) return element.val('');
          var index = typeahead.$getIndex(controller.$modelValue);
          var selected = angular.isDefined(index) ? typeahead.$scope.$matches[index].label : controller.$viewValue;
          selected = angular.isObject(selected) ? parsedOptions.displayValue(selected) : selected;
          element.val(selected ? selected.toString().replace(/<(?:.|\n)*?>/gm, '').trim() : '');
        };

        // Garbage collection
        scope.$on('$destroy', function () {
          if (typeahead) typeahead.destroy();
          options = null;
          typeahead = null;
        });

      }
    };

}]);

/* jshint strict:false  */
angular.module("SumTotalWebpartModule", [])
  .directive('sumtWebpart', function () {
    return {
      restrict: "A",
      scope: true,
      replace: false,
      templateUrl: 'webparts/webpartcontainer_view.html',
      transclude: true,
      link: function (scope, element, attrs) {

        //var defaultClass = 'sumt-webpart-header ';
        var headerClass = attrs.headerClass === '' || attrs.headerClass === undefined ? '' : attrs.headerClass;

        scope.headerTitle = attrs.headerTitle !== '' && attrs.headerTitle !== undefined ? attrs.headerTitle : '';
        scope.headerClass = headerClass;

        scope.headerIcon = attrs.headerIcon !== '' && attrs.headerIcon !== undefined ? attrs.headerIcon : '';

        scope.hideHeader = attrs.hideHeader !== '' && attrs.hideHeader !== undefined ? attrs.hideHeader : false;
        //console.log(scope.headerUrl);
        scope.headerUrl = attrs.headerUrl !== '' && attrs.headerUrl !== undefined ? attrs.headerUrl : false;
        scope.hideDeeplink = attrs.hideDeeplink !== '' && attrs.hideDeeplink !== undefined && attrs.hideDeeplink.toLowerCase() == 'true' ? true : false;
        scope.contentWidth = attrs.contentWidth !== '' && attrs.contentWidth !== undefined ? attrs.contentWidth : undefined;
        scope.contentHeight = attrs.contentHeight !== '' && attrs.contentHeight !== undefined ? attrs.contentHeight : undefined;
        scope.contentClass = attrs.contentClass !== '' && attrs.contentClass !== undefined ? attrs.contentClass : undefined;

        scope.widthObj = {
          width: scope.contentWidth
        };
        scope.heightObj = {
          height: scope.contentHeight
        };
        if (!scope.hideDeeplink) {
          scope.handleHeaderClick = function () {
            window.eval(scope.headerUrl); // jshint ignore:line
          };
        }
        if (scope.headerUrl !== '' && scope.headerUrl !== undefined && !scope.hideDeeplink) {
            scope.headerLinkIcon = 'fa fa-external-link-square';
            scope.headerStyleObj = {
              cursor: "pointer"
            };
          //element.on("click", function () { window.eval(scope.headerUrl); });
        }
      }
    };
  });

  /*

  \param activeStep - current active step of the wizard
  \param onSelectedStep - optional function property used to access the selected step of the wizard when clickable
  \param stepData - array of objects required for the wizard
    - example object:
      {
        stepNum: 0,
        stepName: '',
        stepSubName: '',
        stepDisabled: false,
        stepCompleted: false,
        focusId: ''
      }
  \param nextStep - currently not used
  \param prevStep - currently not used
  \param clickable - optional property used to set whether the wizard is clickable or not
  \param translations = optional object that can be parsed to allow translated values to be used for the accessibile labels
      - example object:
        {
          labelText: 'Steps',
          stepText: 'Step',
          ofText: 'of',
          completedText: 'Completed',
          notCompletedText: 'Not yet completed',
          currentText: 'Current'
        }

  */
  /* jshint strict:false */
  angular.module("SumTotalWizard", [])
    .directive('sumtWizard', ['$timeout', function ($timeout) {
      return {
        restrict: 'EA',
        replace: false,
        transclude: false,
        templateUrl: 'wizard/wizardsteps_view.html',
        scope: {
          activeStep: '=',
          onSelectedStep: '&',
          nextStep: '=',
          prevStep: '=',
          stepData: '=',
          clickable: '=?'
        },
        link: function (scope, element, attrs) { // jshint ignore:line
          scope.stepCount = attrs.numSteps;
          scope.allStepsOpen = true;
          scope.selectedStep = scope.activeStep;

          if(angular.isUndefined(scope.clickable)) {
            scope.clickable = false;
          }

          // default values for translations
          scope.translations = {
            labelText: 'Steps',
            stepText: 'Step',
            ofText: 'of',
            completedText: 'Completed',
            notCompletedText: 'Not yet completed',
            currentText: 'Current'
          }

          //set translations if parsed in
          if(angular.isDefined(attrs.translations)){
            scope.translations = attrs.translations
            var keys = Object.keys(_settings.translations);
            angular.forEach(keys, function(v, i) {
              if(angular.isDefined(attrs.translations[v])) {
                attrs.translations[v] = scope.translations[v];
              }
            })
          }

          scope.$watch('activeStep', function(newValue, oldValue) {
            if (newValue && newValue > 0) {
              scope.selectedStep = newValue;
              scope.onSelectedStep({ selectedStep: scope.selectedStep });
              scope.focusElement();
            }
        }, true);

          if(angular.isUndefined(scope.stepData)) {
            scope.stepData = [];

            for (var i = 1; i <= attrs.numSteps; i++) {
							var step = {
								stepNum: i,
                stepName: '',
                stepSubName: '',
                stepDisabled: false,
                stepCompleted: false,
                focusId: ''
							};

							scope.stepData.push(step);
						}
          }

          angular.forEach(scope.stepData, function(v, i) {
            if(angular.isUndefined(v.stepDisabled)) {
              v.stepDisabled = true;
            }
            if(v.stepDisabled) {
              scope.allStepsOpen = false;
            }
            if(angular.isUndefined(v.stepCompleted)) {
              v.stepCompleted = false;
            }
          })

				/*	if(scope.stepData!=null)
					{
							angular.forEach(scope.stepData, function(value, key) {
									var step = {
									stepNum: value.stepNum,
                  stepName: value.stepName
								};
								scope.stepArray.push(step);
							});
					}
					else
					{
						for (var i = 1; i <= attrs.numSteps; i++) {
							var step = {
								stepNum: i,
                stepName: ''
							};

							scope.stepArray.push(step);
						}
					}*/

          if (attrs.allowDisable !== undefined) {
            scope.disabled = true;
          } else {
            scope.disabled = false;
          }

          scope.nextStep = function () {
            if (scope.activeStep < scope.stepCount) {
              scope.activeStep += 1;
            }
          };

          scope.prevStep = function () {
            if (scope.activeStep > 1) {
              scope.activeStep -= 1;
            }
          };

          scope.focusElement = function() {
            $timeout(function () {
              var step = scope.stepData[scope.selectedStep - 1];
              if(angular.isDefined(step) && angular.isDefined(step.focusId) && step.focusId.length > 0) {
                $('#' + step.focusId).focus();
              }
            }, 500);
          }

          scope.goToStep = function(step) {
            if(angular.isDefined(step) && scope.clickable && (!step.stepDisabled || step.stepNum == scope.activeStep)) {
              scope.selectedStep = step.stepNum;
              scope.onSelectedStep({ selectedStep: scope.selectedStep });
              scope.focusElement();
            }
          }

          scope.step508Label = function(step) {
            var text = '';

            if(step.stepNum == scope.activeStep) {
              text = scope.translations.currentText + ' ' + scope.translations.stepText + ' ' + step.stepNum + ' ' + scope.translations.ofText + ' ' + scope.stepCount + ', ' + step.stepName + (angular.isDefined(step.stepSubName) ? ', ' + step.stepSubName : '');
            }
            else if (step.stepCompleted) {
              text = scope.translations.stepText + ' ' + step.stepNum + ' ' + scope.translations.ofText + ' ' + scope.stepCount + ', ' + step.stepName + (angular.isDefined(step.stepSubName) ? ', ' + step.stepSubName : '') + ', ' + scope.translations.completedText;
            }
            else if (!step.stepCompleted) {
              text = scope.translations.stepText + ' ' + step.stepNum + ' ' + scope.translations.ofText + ' ' + scope.stepCount + ', ' + step.stepName + (angular.isDefined(step.stepSubName) ? ', ' + step.stepSubName : '') + ', ' + scope.translations.notCompletedText;
            }

            return text;
          }
        }
      };
}]);

angular.module('SumTotalComponents').run(['$templateCache', function($templateCache) {$templateCache.put('accordion/accordion-group_view.html','<div class="sumt-accordion-group">\n  <div class="sumt-accordion-heading" ><a class="sumt-accordion-toggle" ng-click="isOpen = !isOpen" accordion-transclude="heading">{{heading}}</a></div>\n  <div class="sumt-accordion-body" collapse="!isOpen">\n    <div class="sumt-accordion-inner" ng-transclude></div>  \n  </div>\n</div>\n');
$templateCache.put('accordion/accordion_view.html','<section accordion heading="Goals">\n  <h2>{{heading}}</h2>\n  <div accordion-group heading="">\n    <div ng-transclude ></div>\n  </div>\n</section>\n');
$templateCache.put('actionGauge/actionGaugeTemplate.html','<div class="action-gauge-container">\n\t<a href="#" class="action-gauge-section" ng-repeat="item in gaugeListItems" ng-click="selectGauge($event, item)" aria-label="{{::(item.title | translate)}} {{::item.count}} {{::(item.description | translate)}}">\n\t\t<div class="gauge-value-section">\t\t\n\t\t\t<div id="gaugeCount_{{$index}}" class="gauge-value" ng-style="{ backgroundColor: item.backgroundColor }" ng-bind="::item.count"></div>\n\t\t\t<div  id="gaugeActiveIndicator_{{$index}}" ng-style="{ color: item.backgroundColor }" class="active-color" ng-class="{\'guageActiveDisplay\': item.gaugeActive == true}">\n\t\t\t\t<i aria-hidden="true" class="fa fa-caret-down fa-3x"></i>\n\t\t\t</div>\t\t\t \n\t\t</div>\n\t\t<div class="gauge-title-section" ng-style="{ backgroundColor: item.backgroundColor }">\n\t\t\t<div id="gaugeTitle_{{$index}}" class="gauge-title" ng-bind="::(item.title | translate)"></div>\n\t\t\t<span id="gaugeDescription_{{$index}}" class="gauge-content" ng-bind="::(item.description | translate)"></span>\n\t\t</div>\t\t\n\t</a>\n</div>');
$templateCache.put('angular-strap/alert.html','<div class="alert" ng-class="[type ? \'alert-\' + type : null]">\n  <span id="confirmationMessage" tabindex="-1" focusmedisabled="{{focusMeDisabled}}" focus-me ></span>\n\n  <strong ng-if="title" aria-level="2" ng-bind="title"></strong>\n  <button role="button" type="button" class="close opacity1" ng-if="dismissable" ng-click="$hide()"><span aria-hidden="true" class="fa fa-times white-color"></span><span class="sr-only" translate="REMOVE_NOTIFICATION_TXT"></span></button>\n  <div>\n    <span id="alertMsg" role="alert" aria-live="assertive" aria-atomic="true" ng-bind-html="content"></span>\n  </div>\n</div>\n');
$templateCache.put('angular-strap/datepicker.html','<div role="presentation" aria-hidden="true" class="dropdown-menu datepicker" ng-class="\'datepicker-mode-\' + $mode" style="max-width: 320px;">\n  <table style="table-layout: fixed; height: 100%; width: 100%;">\n    <thead>\n      <tr class="text-center">\n        <th>\n          <button tabindex="-1" type="button" class="btn btn-default pull-left" ng-click="$selectPane(-1)">\n            <i class="{{$iconLeft}}"></i>\n          </button>\n        </th>\n        <th colspan="{{ rows[0].length - 2 }}">\n          <button tabindex="-1" type="button" class="btn btn-default btn-block text-strong" ng-click="$toggleMode()">\n            <strong style="text-transform: capitalize;" ng-bind="title"></strong>\n          </button>\n        </th>\n        <th>\n          <button tabindex="-1" type="button" class="btn btn-default pull-right" ng-click="$selectPane(+1)">\n            <i class="{{$iconRight}}"></i>\n          </button>\n        </th>\n      </tr>\n      <tr ng-if="showLabels" ng-bind-html="labels"></tr>\n    </thead>\n    <tbody>\n      <tr ng-repeat="(i, row) in rows" height="{{ 100 / rows.length }}%">\n        <td class="text-center" ng-repeat="(j, el) in row">\n          <button tabindex="-1" type="button" class="btn btn-default" style="width: 100%" ng-class="{\'btn-primary\': el.selected, \'btn-info btn-today\': el.isToday && !el.selected}" ng-click="$select(el.date)" ng-disabled="el.disabled">\n            <span ng-class="{\'text-muted\': el.muted}" ng-bind="el.label"></span>\n          </button>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n</div>\n');
$templateCache.put('charts/animatedPieChart.html','<div class="pieChartContainer">\n  <span ng-if="!isInteractive" class="sr-only">{{ accessLabel }}</span>\n  <div class="chartdiv"></div>\n  <table class="table sr-only" role="presentation">\n    <thead>\n      <tr>\n        <th ng-repeat="item in chart.chartData" ng-bind="::item.title"></th>\n      </tr>\n    </thead>\n    <tbody>\n      <tr>\n        <td ng-repeat="valueItem in chart.chartData" ng-bind="::valueItem.value"></td>\n      </tr>\n    </tbody>\n  </table>\n</div>\n');
$templateCache.put('charts/axisBreakChart.html','<div>\n  <div class="barChartContainer" ng-style="getContainerStyle()">\n    <div class="chartdiv" ng-style="getChartStyle()"></div>\n  </div>\n  <table class="table sr-only">\n    <thead>\n      <tr>\n        <th ng-if="::chart.categoryField" ng-bind="::chart.categoryField"></th>\n        <th ng-repeat="item in ::chart.graphs" ng-bind="::item.valueField"></th>\n      </tr>\n    </thead>\n    <tbody>\n      <tr ng-repeat="detail in ::chart.dataProvider">\n        <td ng-repeat="(key, value) in ::detail" ng-bind="::value"></td>\n      </tr>\n    </tbody>\n  </table>\n</div>\n');
$templateCache.put('charts/barchart.html','<div>\n  <div class="barChartContainer">\n    <div class="chartdiv" ng-style="getChartStyle()"></div>\n  </div>\n  <table class="table sr-only">\n    <thead>\n      <tr>\n        <th ng-if="::chart.categoryField" ng-bind="::chart.categoryField"></th>\n        <th ng-repeat="item in ::chart.graphs" ng-bind="::item.valueField"></th>\n      </tr>\n    </thead>\n    <tbody>\n      <tr ng-repeat="detail in ::chart.dataProvider">\n        <td ng-repeat="(key, value) in ::detail" ng-bind="::value"></td>\n      </tr>\n    </tbody>\n  </table>\n</div>\n');
$templateCache.put('charts/bellchart.html','<div>\n  <div class="bellChartContainer" aria-hidden="true">\n    <div class="chartdiv" ng-style="getChartStyle()"></div>\n  </div>\n  <table class="table sr-only">\n    <thead>\n      <tr>\n        <th ng-if="::bellchart.categoryField" ng-bind="::bellchart.categoryField"></th>\n        <th ng-repeat="item in ::bellchart.graphs" ng-bind="::item.valueField"></th>\n      </tr>\n    </thead>\n    <tbody>\n      <tr ng-repeat="detail in ::bellchart.dataProvider">\n        <td ng-repeat="(key, value) in ::detail" ng-bind="::value"></td>\n      </tr>\n    </tbody>\n  </table>\n</div>\n');
$templateCache.put('charts/linechart.html','<div>\n  <div class="lineChartContainer" aria-hidden="true">\n    <div class="chartdiv" ng-style="getChartStyle()"></div>\n  </div>\n  <table class="table sr-only">\n    <thead>\n      <tr>\n        <th ng-if="::chart.categoryField" ng-bind="::chart.categoryField"></th>\n        <th ng-repeat="item in ::chart.graphs" ng-bind="::item.valueField"></th>\n      </tr>\n    </thead>\n    <tbody>\n      <tr ng-repeat="detail in ::chart.dataProvider">\n        <td ng-repeat="(key, value) in ::detail" ng-bind="::value"></td>\n      </tr>\n    </tbody>\n  </table>\n</div>\n');
$templateCache.put('charts/piechart.html','<div class="pieChartContainer" ng-multi-transclude-controller>\n  <span ng-if="!isInteractive" class="sr-only">{{ accessLabel }}</span>\n  <div class="donutLabel" aria-hidden="true" ng-style="chartStyle" measurement="measurement">\n    <div ng-bind="donutLabelValue" ng-if="::showDonutLabel && showDonutStatusLabel!=true"></div>\n    <div ng-if="::showDonutLabel && showDonutStatusLabel">\n      <div class="h3 donutLabelValue" ng-bind="donutLabelValue"></div>\n      <div class="h4 donutStatusValue" ng-bind="donutStatusValue" ng-if="::showDonutStatusLabel"></div>\n    </div>\n    <div ng-multi-transclude="customlabel"></div>\n  </div>\n  <div class="chartdiv"></div>\n  <!-- Only display the table if chartData consists of more than 1 property other than "Gap" per SS-6194 -->\n  <table class="table sr-only" role="presentation" ng-if="chart.chartData.length > 2">\n    <thead>\n      <tr>\n        <th ng-repeat="item in chart.chartData" ng-bind="::item.title"></th>\n      </tr>\n    </thead>\n    <tbody>\n      <tr>\n        <td ng-repeat="valueItem in chart.chartData" ng-bind="::formatChartNumber(valueItem.percents) + measurement"></td>\n      </tr>\n    </tbody>\n  </table>\n</div>\n');
$templateCache.put('claw/behaviors_list.html','<table class="table table-responsive" ng-if="behaviors.length>0">\n    <thead>\n        <tr>\n            <th translate="POSITIONFIT_BEHAVIORS"></th>\n            <th translate="POSITIONFIT_ACQUIRED_PROFICIENCY"></th>\n            <th translate="POSITIONFIT_TARGET_PROFICIENCY"></th>\n        </tr>\n    </thead>\n    <tbody>\n        <tr ng-repeat="i in behaviors">\n            <td ng-if="::!displayFullText" ng-bind="::(i.name | limitTo: 100)+(i.name.length>100?\'...\':\'\')" class="clawTableWordBreak clawTableDescCol"></td>\n            <td ng-if="::displayFullText" ng-bind="::i.name" class="clawTableDescCol"></td>\n            <td ng-bind="::i.acquiredProficiency" class="clawTableWordBreak clawTableNameCol"></td>\n            <td ng-bind="::i.requiredProficiency" class="clawTableWordBreak clawTableNameCol"></td>\n        </tr>\n    </tbody>\n</table>\n<p ng-if="behaviors.length==0" translate="NAVIGATIONS_NODATA_AVAILABLE"></p>\n');
$templateCache.put('claw/claw_view.html','<div ng-show="clawVisible" class="clawBubbleContainer" ng-style="{width: chartWidth}">\n  <div class="clawContainer" ng-style="{width: canvas.width}">\n    <div class="clawheader" ng-class="{\'legend-hidden\': selectedChartViewType == \'list\'}">\n      <h4>{{gapCount}}\n        <label translate="POSITIONFIT_GAPCOUNT"></label>\n      </h4>\n      <div class="legendContainer" ng-show="selectedChartViewType == \'chart\'" aria-hidden="true">\n        <table>\n          <tr>\n            <td>\n              <span class="h4" translate="POSITIONFIT_IMPACTCAPABILITY"></span>\n            </td>\n            <td ng-repeat-start="c in config.legendColors.slice().reverse()">\n              <div class="legendRec" ng-style="{background: getColor(c)}"></div>\n            </td>\n            <td ng-repeat-end ng-hide="$last == true">\n              <i class="fa fa-arrow-right"></i>\n            </td>\n          </tr>\n          <tr>\n            <td></td>\n            <td ng-repeat-start="c in config.legendColorLabels.slice().reverse()" translate="{{c}}"></td>\n            <td ng-repeat-end ng-hide="$last == true"></td>\n          </tr>\n        </table>\n      </div>\n      <div class="chart-view-toggler-container chart-list-toggle-container">\n        <input type="radio" name="claw_view" id="claw_chart_view_chart_radio_btn" ng-value="\'chart\'" class="chart" ng-model="selectedChartViewType">\n        <label for="claw_chart_view_chart_radio_btn"><span class="sr-only" translate="CHART_VIEW_MODE_CHART"></span></label>\n\n\n        <input type="radio" name="claw_view" id="claw_chart_view_list_radio_btn" ng-value="\'list\'" class="list" ng-model="selectedChartViewType">\n        <label for="claw_chart_view_list_radio_btn"><span class="sr-only" translate="CHART_VIEW_MODE_LIST"></span></label>\n      </div>\n    </div>\n    <div class="chart-view" ng-show="selectedChartViewType == \'chart\'" aria-hidden="true">\n      <canvas id="clawCanvas" height="{canvas.height}" width="{canvas.width}" aria-describedby="clawTable"></canvas>\n      <canvas tooltip="" id="clawtip" width="100" height="25"></canvas>\n      <div class="sr-only" id="clawTable">\n        <table ng-repeat="item in data">\n          <tr>\n            <td colspan="2" ng-bind="item.id"></td>\n          </tr>\n          <tr ng-repeat="i in item.items">\n            <td ng-bind="i.name"></td>\n            <td ng-bind="i.percent"></td>\n          </tr>\n        </table>\n      </div>\n      <div class="clawLabelContainer">\n        <h5 ng-style="{width:cX}" translate="POSITIONFIT_CLAWLABEL"></h5>\n        <h5 ng-style="{width:competencyWidth}" translate="POSITIONFIT_CAPABILITY"></h5>\n        <h5 ng-style="{width:labelStyle}" translate="POSITIONFIT_CURRENT_CAPABILITY"></h5>\n      </div>\n      <div class="clawListContainer">\n        <div ng-transclude ng-if="transclusion"></div>\n        <div ng-if="!transclusion">\n          <!-- JOB FIT CATEGORIES - AQUIRED ITEMS -->\n          <claw-chart-skills-list skills="::completedActivities" ng-if="tableDisplayContent==\'POSITIONFIT_SKILLS\'"></claw-chart-skills-list>\n          <claw-chart-behaviors-list behaviors="::completedActivities" ng-if="tableDisplayContent==\'POSITIONFIT_BEHAVIORS\'"></claw-chart-behaviors-list>\n          <claw-chart-learning-list learning-data="::completedActivities" ng-if="tableDisplayContent==\'POSITIONFIT_LEARNING\'"></claw-chart-learning-list>\n\n          <!-- HEADERS (skills, learning, behaviors that sit above the \'capabilities\' label) -->\n          <claw-chart-gaps-list items="::selectedCapability.items" category-name="::selectedGap.categoryName" header-name="\'POSITIONFIT_TABLEHEADER_GAPDETAILS\'"\n            ng-if="tableDisplayContent==\'Headers\'" filter-complete="true"></claw-chart-gaps-list>\n\n          <!-- DETAILED INFO - EACH INDIVIDUAL ITEM ON THE RIGHT SIDE OF THE GRAPH -->\n          <claw-chart-gaps-list items="::selectedGap.items" category-name="selectedGap.categoryName" header-name="\'POSITIONFIT_TABLEHEADER_NAME\'"\n            ng-if="tableDisplayContent==\'Gaps\'"></claw-chart-gaps-list>\n        </div>\n      </div>\n    </div>\n    <div class="list-view" ng-if="selectedChartViewType == \'list\'">\n      <div bs-tabs data-bs-active-pane="activeTabData">\n        <div ng-repeat="tab in data" data-title="{{::tab.id}} ({{::tab.percent}}%)" name="{{::tab.categoryKey}}" bs-pane>\n          <h3 class="text-uppercase" translate="POSITIONFIT_TABLEHEADER_ACQUIRED"></h3>\n          <claw-chart-skills-list display-full-text="true" skills="::tab.completedActivities" ng-if="::tab.categoryKey==\'POSITIONFIT_SKILLS\'"></claw-chart-skills-list>\n          <claw-chart-behaviors-list display-full-text="true" behaviors="::tab.completedActivities" ng-if="::tab.categoryKey==\'POSITIONFIT_BEHAVIORS\'"></claw-chart-behaviors-list>\n          <claw-chart-learning-list display-full-text="true" learning-data="::tab.completedActivities" ng-if="::tab.categoryKey==\'POSITIONFIT_LEARNING\'"></claw-chart-learning-list>\n\n          <h3 class="text-uppercase" translate="POSITIONFIT_GAPCOUNT"></h3>\n          <claw-chart-gaps-list items="::tab.items" category-name="::tab.categoryKey" show-details="true" header-name="\'POSITIONFIT_TABLEHEADER_GAPDETAILS\'" filter-complete="true"></claw-chart-gaps-list>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n');
$templateCache.put('claw/gap_info_list.html','<table class="table table-responsive" ng-if="$items.length>0">\n    <thead>\n        <tr>\n            <th translate="{{::headerName}}"></th>\n            <th translate="POSITIONFIT_TABLEHEADER_DESCRIPTION"></th>\n            <th translate="POSITIONFIT_TABLEHEADER_IMPACT"></th>\n            <th ng-if="::categoryName == \'POSITIONFIT_LEARNING\'">&nbsp;</th>\n        </tr>\n    </thead>\n    <tbody>\n        <tr ng-repeat="i in $items" style="height: 62px">\n            <td ng-if="::!displayFullText" class="clawTableWordBreak clawTableNameCol" ng-bind="::(i.name | limitTo: 100)+(i.name.length>100?\'...\':\'\')"></td>\n            <td ng-if="::displayFullText" class="clawTableNameCol" ng-bind="::i.name"></td>\n\n            <td ng-if="::!displayFullText" class="clawTableWordBreak clawTableDescCol" ng-bind="::(i.description | limitTo: 250)+(i.description.length>250?\'...\':\'\')"></td>\n            <td ng-if="::displayFullText" class="clawTableDescCol" ng-bind="::i.description"></td>\n\n            <td class="clawTableWordBreak clawTableValueCol" ng-if="::(i.value && !showDetails)" ng-bind="::i.value + \'%\'"></td>\n            <td class="clawTableValueCol" ng-if="::(i.percent && !$config)" ng-bind="::(i.percent + \'%\')"></td>\n            <td class="clawTableValueCol" ng-if="::(i.percent && $config)" ng-bind="::(i.percent + \'% (\' + $config[i.color] + \') \')"></td>\n\n            <td ng-if="::categoryName == \'POSITIONFIT_LEARNING\'" class="clawTableWordBreak clawTableActionCol">\n                <div ng-show="::i.actions!= null && i.actions.length > 0" class="btn-group">\n                    <button type="button" ng-bind="i.actions[0].Name" ng-click="activityActionBtnClick(i.actions[0], i.activityId)" class="btn btn-primary" aria-label="{{i.actions[0].Name}} {{i.name}}"></button>\n                    <button class="btn btn-primary dropdown-toggle clawGapSplitButton"\n                        data-placement="bottom-right"\n                        bs-dropdown\n                        data-toggle="dropdown"\n                        aria-haspopup="true"\n                        aria-expanded="false">\n                        <span class="caret"></span>\n                        <span class="sr-only" ng-bind="::\'TIMELINE_SLIDEOUT_TOGGLE_DROPDOWN\' | translate"></span>\n                    </button>\n                    <ul class="dropdown-menu  menu-pull-right" role="menu">\n                        <li ng-repeat="action in i.actions" ng-if="$index > 0">\n                            <a role="menuitem" ng-bind="::action.Name" href="javascript:void(0);" ng-click="activityActionBtnClick(action, i.activityId)" aria-label="{{action.Name}} {{i.name}}"></a>\n                        </li>\n                    </ul>\n                </div>\n            </td>\n        </tr>\n    </tbody>\n</table>\n<p ng-if="$items.length==0" translate="NAVIGATIONS_NODATA_AVAILABLE"></p>\n');
$templateCache.put('claw/learning_list.html','<table class="table table-responsive" ng-if="learningData.length>0">\n    <thead>\n        <tr>\n            <th translate="POSITIONFIT_TABLEHEADER_ACTIVITY"></th>\n            <th translate="POSITIONFIT_TABLEHEADER_DATETAKEN"></th>\n        </tr>\n    </thead>\n    <tbody>\n        <tr ng-repeat="i in learningData">\n            <td ng-if="::!displayFullText" ng-bind="::(i.name | limitTo: 100)+(i.name.length>100?\'...\':\'\')" class="clawTableWordBreak clawTableDescCol"></td>\n            <td ng-if="::displayFullText" ng-bind="::i.name" class="clawTableDescCol"></td>\n            <td ng-bind="::i.completionDate | date:\'shortDate\'" class="clawTableWordBreak clawTablePercentCol"></td>\n        </tr>\n    </tbody>\n</table>\n<p ng-if="learningData.length==0" translate="NAVIGATIONS_NODATA_AVAILABLE"></p>\n');
$templateCache.put('claw/skills_list.html','<table class="table table-responsive" ng-if="skills.length>0">\n    <thead>\n        <tr>\n            <th translate="POSITIONFIT_TABLEHEADER_SKILL"></th>\n            <th translate="POSITIONFIT_TABLEHEADER_ACQUIRED"></th>\n            <th translate="POSITIONFIT_TABLEHEADER_TARGET"></th>\n        </tr>\n    </thead>\n    <tbody>\n        <tr ng-repeat="i in skills">\n            <td ng-if="::!displayFullText" ng-bind="::(i.name | limitTo: 100)+(i.name.length>100?\'...\':\'\')" class="clawTableWordBreak clawTableDescCol"></td>\n            <td ng-if="::displayFullText" ng-bind="::i.name" class="clawTableDescCol"></td>\n            <td ng-bind="::i.acquiredProficiency" class="clawTableWordBreak clawTableNameCol"></td>\n            <td ng-bind="::i.requiredProficiency" class="clawTableWordBreak clawTableNameCol"></td>\n        </tr>\n    </tbody>\n</table>\n<p ng-if="skills.length==0" translate="NAVIGATIONS_NODATA_AVAILABLE"></p>\n');
$templateCache.put('datepicker/datepicker.html','<div class="sumt-datepicker form-group">\n  <div class="datepickerlabeldiv">\n    <label id="datepickerlabelid" ng-if="::labelInput && textboxPlaceholder" class="control-label" ng-attr-for="{{::inputId}}" ng-bind="::(labelInput | translate) + \' (\' + (textboxPlaceholder) + \')\'"></label>\n    <label id="datepickerlabelid" ng-if="::labelInput && !textboxPlaceholder" class="control-label" ng-attr-for="{{::inputId}}" ng-bind="::(labelInput | translate)"></label>\n    <div aria-live="assertive">\n      <span id="{{alertSpanId}}" class="validationSetting">{{dateInputAlert | translate : alertValuesObject}}</span>\n    </div>\n  </div>\n  <input id="{{::inputId}}" name="{{::inputName}}" ng-blur="inputBlur(this)" aria-invalid="{{dateInvalid}}" ng-attr-title="{{::labelInput | translate}}" type="text" class="form-control" ng-model="ngModelDate"\n         bs-datepicker-display ng-required="required" ng-disabled="disabled || readonlyText" ng-attr-placeholder="{{\'DATEPICKER_PLACEHOLDER\' | translate}} {{placeholderdateFormat || undefined}}"\n         timezone="{{::timezone}}" ng-readonly="readonly" aria-describedby="date_format_instructions dateError" min-date="{{minDate}}" max-date="{{maxDate}}" date-format="{{dateFormat}}" />\n\n\n  <button tabindex="0" aria-hidden="true" id="{{::pickerId}}" class="btn btn-default calendar-toggle" type="button" ng-attr-title="{{::labelInput | translate}}" role="button"\n          ng-model="ngModelDate" autoclose="1" min-date="{{minDate}}" max-date="{{maxDate}}" trigger="click focus" \n          bs-datepicker  label-next="{{::labelNext | translate}}" label-previous="{{::labelPrevious | translate}}" label-month="{{::labelMonth | translate}}"\n          label-year="{{::labelYear | translate}}" label-days="{{::labelDays | translate}}" ng-disabled="disabled || readonly" data-placement="{{::placement}}"\n          date-format="{{::dateFormat}}" timezone="{{::timezone}}" ng-attr-aria-label="{{\'COMMON_DATE_CHOOSE\' | translate}} {{::labelInput | translate}}">\n    <i aria-hidden="true" class="fa fa-calendar"></i>\n  </button>\n  <div ng-if="showCultureFormat" class="datepickerlabeldiv">\n    <span id="date_format_instructions">(<span class="sr-only">{{\'DATEPICKER_TEXT_FORMAT\' | translate}}</span>{{::dateFormat | uppercase}})</span>\n  </div>\n</div>\n');
$templateCache.put('forms/text.html','<div id="formWrapper" ng-form="{{validatedName}}" class="form-group has-feedback" ng-class="getFormGroupClass({{validatedName}}.userinputtext.$invalid, {{validatedName}}.userinputtext.$dirty, {{validatedName}}.userinputtext.$valid)">\n  <label class="control-label" for="exampleForm_usersname">{{validatedLabel()}}</label>\n  <input type="text" required class="form-control" ng-model="controlData" name="userinputtext" id="exampleForm_usersname" aria-describedby="inputSuccess2Status" />\n  <span class="fa fa-check form-control-feedback" ng-show="{{validatedName}}.userinputtext.$valid && {{validatedName}}.userinputtext.$dirty" aria-hidden="true"></span>\n  <span class="fa fa-times form-control-feedback" ng-show="{{validatedName}}.userinputtext.$invalid && {{validatedName}}.userinputtext.$dirty" aria-hidden="true"></span>\n  <span id="inputSuccess2Status" class="sr-only" ng-show="{{validatedName}}.userinputtext.$valid">(success)</span>\n</div>\n');
$templateCache.put('leftnav/leftnav_content_template_view.html','<div class="aside ng-scope left leftnav am-slide-left" tabindex="-1" role="dialog" style="display: block;">\n  <div class="aside-dialog">\n    <div class="aside-content">\n\n      <div ng-if="title.nodeKey  == \'self_header\'">\n        <div class="aside-header" ng-show="title">\n          <div selfheader persondata="persondata" emulation="emulation" imageclicked="imageclicked()" exitemulation="exitemulation()" ></div>\n          <i class="fa fa-times" ng-click="close()"></i>\n        </div>\n        <div class="aside-body">\n          <nav ng-repeat="rootNode in ::navData" ng-if="rootNode == selectedNavData">\n            <div ui-tree data-drag-enabled="false" id="tree-root" class="leftNavigationBackground">\n              <ul ui-tree-nodes ng-model="::rootNode.childNodes">\n                <li ng-repeat="node in ::rootNode.childNodes" ui-tree-node ng-include="\'leftnav_renderer.html\'" collapsed="true"></li>\n              </ul>\n            </div>\n          </nav>\n        </div>\n      </div>\n      <div ng-if="title.nodeKey != \'self_header\'">\n        <div class="aside-header aside-headerSelf" ng-show="title">\n          <h2 ng-if="title.url != null && title.url != \'\'" class="aside-title" ng-bind="title.name" ng-click="navigateToAdmin(title)" style="margin-bottom: 0px;"></h2>\n          <h2 ng-if="(title.url == null || title.url == \'\')" class="aside-title" ng-bind="title.name"></h2>\n\t\t  <div class="domain_Header" ng-if="title.nodeKey == \'admin_header\' && switchdomain.Isenabled">\n\t\t   <p class="aside-title domain_change" style="margin:0px" bs-tooltip data-placement="bottom" data-title="{{switchdomain.name}}" data-container="body">{{::translationobject.domain}}: {{switchdomain.name}} \n\t\t  <i class="fa fa-pencil editDomain domain_editicone" ng-click="navigateToAdmin(switchdomain)"></i>\n\t\t  <span class="editDomain aside-title" ng-click="navigateToAdmin(switchdomain)">{{::translationobject.edit}}</span>\n\t\t  </p>\n\t\t  </div>\n          <i class="fa fa-times" ng-click="close()"></i>\n        </div>\n        <div class="aside-body aside-bodySelf">\n          <nav ng-repeat="rootNode in ::navData" ng-if="rootNode == selectedNavData">\n            <div ui-tree data-drag-enabled="false" id="tree-root" class="leftNavigationBackground">\n              <ul ui-tree-nodes ng-model="::rootNode.childNodes">\n                <li ng-repeat="node in ::rootNode.childNodes" ui-tree-node ng-include="\'leftnav_renderer.html\'"  collapsed="true"></li>\n              </ul>\n            </div>\n          </nav>\n        </div>\n      </div>\n\n\n\n    </div>\n  </div>\n  <script type="text/ng-template" id="leftnav_renderer.html">\n    <div ui-tree-handle ng-if="::(node.level != 1)" ng-class="::{\'negativeAlign\': node.level > 2}" class="tree-node tree-node-content" tabindex="-1">\n      <i class="fa pull-left" tabindex="-1" ng-class="{\'fa-caret-right rightArrow\': collapsed && node.childNodes.length > 0, \'fa-caret-down downArrow\': !collapsed && node.childNodes.length > 0 }" ng-if="::(node.level > 2)" ng-click="handleNodes(node, this)"></i>\n      <i class="{{::node.iconPath}} navnodeicon pull-left" ng-if="::node.iconPath"></i>\n      <div class="tree-node-title clearfix" ng-if="::(node.level != 1)">\n        <div ng-click="handleNodeSelected(node, this)" style="word-wrap: break-word;">\n          <div ng-if="(!collapsed && node.childNodes.length > 0)" ng-click="navigateToNode(node)" style="width: 85%;font-weight: 600;" class="pull-left" ng-bind=\'::node.activitiesCount>0 ? node.name + " (" + node.activitiesCount + ")" : node.name\' tabindex="-1"></div>\n          <div ng-if="(collapsed || node.childNodes.length==0)" ng-click="navigateToNode(node)" style="width: 85%;" class="pull-left" ng-bind=\'::node.activitiesCount>0 ? node.name + " (" + node.activitiesCount + ")" : node.name\' tabindex="-1"></div>\n        </div>\n        <div ng-if="::(node.childNodes.length > 0)" style="width:10%;float:right">\n          <i class="fa fa-lg fa-fw angleArrow pull-right" ng-class="{\'fa-angle-right\': collapsed && node.childNodes.length > 0, \'fa-angle-down\': !collapsed && node.childNodes.length > 0}" ng-if="::(node.level == 2)" ng-click="handleNodes(node, this)"></i>\n        </div>\n      </div>\n    </div>\n    <ol ui-tree-nodes="" ng-model="::node.childNodes" ng-class="{hidden: collapsed, spacing: node.level == 2}">\n      <li ng-repeat="node in ::node.childNodes" ui-tree-node ng-include="\'leftnav_renderer.html\'" collapsed="true"></li>\n    </ol>\n  </script>\n</div>\n');
$templateCache.put('leftnav/leftnav_panels_view.html','<nav class="sidePanelNavContainer">\n  <ul class="nav">\n    <li ng-repeat=\'panel in ::panels() track by $index\'>\n      <a href="{{\'#\'+panel.id}}" ng-click="expand = !expand" ng-bind="::panel.title"></a>\n      <i ng-if="::panel.children" ng-click="expand = !expand" ng-class="expand ? \'fa fa-angle-down\' : \'fa fa-angle-right\'"></i>\n      <div class="sidePanelChildContainer" ng-show="expand">\n        <div ng-repeat=\'child in ::panel.children\'>\n          <a ng-bind="::child.title"></a>\n        </div>\n      </div>\n    </li>\n  </ul>\n</nav>\n');
$templateCache.put('leftnav/leftnav_view.html','<div class="leftNavWrapper asid-slide-left" ng-class="{\'asideExpanded\': leftNavigationObject.isShown}">\n  <div ng-transclude></div>\n</div>\n');
$templateCache.put('leftnav/self_header.html','<div class="left-nav-image">\n  <div sumt-keymeasure-chart chart-data="{{persondata.KeyMeasureValue}}" chart-width="70px" chart-height="70px" ng-click="imageclicked()">\n\t<img ng-if="persondata.ImagePath != \'\'" ng-src="{{persondata.ImagePath}}" class="left-nav-headerImage" ng-click="imageclicked()"></img>\n\t<div ng-if="persondata.ImagePath == \'\'" class="navheader" ng-click="imageclicked()">\n\t\t<i  class="fa fa-user fa-3x navheadericon" ></i>\n\t</div>\n\t</div>\n\t<div class="left-nav-headertitle">\n\t\t<p id="username" class="left-nav-headerdetails" ng-bind="persondata.FirstName+\' \'+ persondata.LastName" ng-class="{\'left-nav-headerdetails\': !emulation, \'left-nav-headeremulation\': emulation}" ng-click="imageclicked()"></p>\n\t\t<p class="left-nav-headersubtitle" ng-bind="persondata.JobTitle" ng-click="imageclicked()" bs-tooltip data-placement="bottom" data-title="{{persondata.JobTitle}}" data-container="body"></p>\n\t\t<p class="left-nav-exitemulation"  ng-if="emulation && emulation.IsEmulationEnabled == true" ng-click="exitemulation()">Exit Emulation</p>\n\t</div>\n</div>\n\n');
$templateCache.put('liveregion/liveregion_view.html','<div class="sr-only" aria-live="{{sumtliveregion.curMessage.ariaLevel || \'off\'}}" \n  ng-attr-aria-describedby="{{sumtliveregion.curMessage.ariaDescribedBy}}"\n  ng-attr-aria-atomic="{{sumtliveregion.curMessage.ariaAtomic}}"\n  ng-attr-aria-labelledby="{{sumtliveregion.curMessage.ariaLabeledBy}}"\n  ng-attr-aria-relevant="{{sumtliveregion.curMessage.ariaRelevant || undefined}}" ng-bind-html="sumtliveregion.curMessage.msg">\n  <!-- {{sumtliveregion.curMessage.msg}} -->\n  <!-- {{sumtliveregion.curMessage.nextMsg}} -->\n  <!-- <button aria-label="{{sumtliveregion.curMessage.nextMsg}}" ng-if="sumtliveregion.curMessage.nextMsg">{{sumtliveregion.curMessage.nextMsg}}</button> -->\n</div>');
$templateCache.put('modalfilter/modalfilter_view.html','<div class="modal-filter" ng-show="modalityList.length>0">\n  <ul role="tablist">\n    <li class="{{\'move\' + directiveId}}" role="tab" data-toggle="tab" data-index="0" aria-controls="{{tabpanelId}}" aria-selected="{{currentlySelectedFilter == MODALFILTER_ALL ? \'true\' : \'false\'}}" tabindex="{{currentlySelectedFilter == MODALFILTER_ALL ? \'0\' : \'-1\'}}" id="filter-all" ng-class="currentlySelectedFilter == MODALFILTER_ALL ? \'activeFilter\' : \'inactiveFilter\'" ng-click="$showAll()" ng-focus="$showAll()">\n      <a role="presentation" ng-bind="titleAll"></a>\n    </li>\n    <li class="{{\'move\' + directiveId}}" role="tab" data-toggle="tab" data-index="1" aria-controls="{{tabpanelId}}" ng-repeat="filter in modalityList | orderBy : \'ModalityDisplayOrder\'" tabindex="{{currentlySelectedFilter == filter.ModalityId ? 0 : -1}}" ng-class="currentlySelectedFilter == filter.ModalityId ? \'activeFilter\' : \'inactiveFilter\'" ng-click="showCurrentFilter(filter)" ng-focus="showCurrentFilter(filter)">\n      <i class="{{filter.ModalityIcon}}"></i>\n      <a role="presentation" ng-bind="filter.ModalityName"></a>\n    </li>\n  </ul>\n</div>');
$templateCache.put('notificationTile/notificationTile_view.html','<div ng-repeat="notif in notifications track by $index" ng-show="pagination === \'false\' || currentPage === $index + 1" class="notificationTile" ng-class="{\'selected\': selected === true}">\n  <div class="iconContainer"><i class="{{notif.icon}}"></i></div>\n  <div class="notificationSection" ng-repeat="item in notif.sections track by $index" ng-class="getClass(item)">\n    <h3>{{item.heading}}</h3>\n    <h4>{{item.definition}}</h4>\n  </div>\n  <div ng-show="pagination === \'true\'" class="pageContainer">\n    <div ng-repeat="p in getPages() track by $index" class="pageDot" ng-click="setPage($index + 1)" ng-class="{\'pageDotSel\': currentPage !== $index + 1}"></div>\n  </div>\n  <label ng-show="pagination === \'false\'" class="checkBox"><input ng-model="selected" type="checkbox"/><span></span></label>\n</div>\n');
$templateCache.put('progress-bar/progress-bar.html','<div id="progress-control">\n  <div class="widget-header">\n    <h2>\n      <span translate="PROGRESS_HEADER" title="{{\'PROGRESS_HEADER\'|translate}}"></span>:\n      <span ng-attr-title="{{additionalHeadingContent}}" ng-if="additionalHeadingContent !== undefined">\n        <span>{{additionalHeadingContent}}</span>\n      </span>\n    </h2>\n  </div>  \n  <div class="progress-instruction-container">\n  <p class="progress-instruction" role="presentation" ng-attr-title="{{instructionContent | translate}}" ng-if="instructionContent !== undefined" ng-class="hideEllipsis()">\n    <span class="actual-instruction-content">{{instructionContent | translate}}</span>    \n  </p>\n  </div>  \n  <div class="progress-container">\n  <span id="progressBarDescription" class="sr-only" translate="PROGRESS_BAR_DESCRIPTION"></span>\n    <div class="progress-bar-display">\n      <div class="prgress-bar-wrapper">\n\t  <span id="completedButtonDescription" class="sr-only" translate="PROGRESS_BAR_DESCRIPTION_COMPLETED"></span>\n        <div class="progress progress-extn" attr-translate-aria-label="PROGRESS_BAR_LABEL" aria-describedby="progressBarDescription">\n          <div ng-if="filterByStatusBar == undefined" aria-labelledby="idcompletedPercent id_Complted" class="progress-bar progress-bar-complete progress-bar-focus" aria-describedby="completedButtonDescription"></div>\n          <div ng-if="filterByStatusBar != undefined" ng-click="statusBarFilter(\'completed\')" ng-class="{\'progress-bar-opacity\': (taskStatus !=undefined) && (taskStatus == \'ongoing\' || taskStatus == \'pending\')}" data-trigger="focus hover" aria-labelledby="{{(showPercent && completedPercent ==100) ? \'idcompletedPercent\':\'idcompletedPercent id_Complted\'}}" class="progress-bar progress-bar-complete complete-width progress-bar-focus" bs-tooltip data-container="body" data-placement="bottom" data-title="{{completedTooltip}}" aria-describedby="completedButtonDescription completedTaskTooltip"></div>\n        </div>\n        <span id="completedTaskTooltip" class="sr-only" ng-bind="completedTooltip"></span>\n      </div>\n      <div class="progress-text">\n        <div id="idcompletedPercent" title="{{completedPercent}}{{\'PROGRESS_PERCENT_STATUS_COMPLETED\'|translate}}" class="progress-value" translate="PROGRESS_PERCENT_STATUS_COMPLETED" ng-class="{\'zero-progress\':completedPercent ===0 || (taskStatus !=undefined) && (taskStatus == \'ongoing\' || taskStatus == \'pending\')}" translate-values="{percentValue:completedPercent}" ng-if="showPercent"></div>\n      </div>\n    </div>\t\n    <div class="progress-bar-display">\n      <div class="prgress-bar-wrapper">\n\t  <span id="inProgressButtonDescription" class="sr-only" translate="PROGRESS_BAR_DESCRIPTION_INPROGRESS"></span>\n        <div class="progress progress-extn" attr-translate-aria-label="PROGRESS_BAR_LABEL" aria-describedby="progressBarDescription">\n\n          <div ng-if="filterByStatusBar == undefined" aria-labelledby="idongoingPercent id_Ongoing" class="progress-bar progress-bar-ongoing ongoing-width progress-bar-focus" aria-describedby="inProgressButtonDescription"></div>\n          <div ng-if="filterByStatusBar != undefined" ng-click="statusBarFilter(\'ongoing\')" ng-class="{\'progress-bar-opacity\': (taskStatus !=undefined) && (taskStatus === \'pending\'|| taskStatus === \'completed\')}" data-trigger=" focus hover" aria-labelledby="{{(showPercent && ongoingPercent ==100) ? \'idongoingPercent\':\'idongoingPercent id_Ongoing\'}}" class="progress-bar progress-bar-ongoing ongoing-width progress-bar-focus" bs-tooltip data-container="body" data-placement="bottom" data-title="{{ongoingTooltip}}" aria-describedby="inProgressButtonDescription inProgressTaskTooltip"></div>\n        </div>\n        <span id="inProgressTaskTooltip" class="sr-only" ng-bind="ongoingTooltip"></span>\n      </div>\n      <div class="progress-text">\n        <div id="idongoingPercent" title="{{ongoingPercent}}{{\'PROGRESS_PERCENT_STATUS_INPROGRESS\'|translate}}" class="progress-value" translate="PROGRESS_PERCENT_STATUS_INPROGRESS" ng-class="{\'zero-progress\':ongoingPercent ==0 || (taskStatus !=undefined) && (taskStatus === \'pending\'|| taskStatus === \'completed\')}" translate-values="{percentValue: ongoingPercent}" ng-if="showPercent"></div>\n      </div>\n    </div>\t\n    <div class="progress-bar-display">\n      <div class="prgress-bar-wrapper">\n\t  <span id="notStartedButtonDescription" class="sr-only" translate="PROGRESS_BAR_DESCRIPTION_NOTSTARTED"></span>\n        <div class="progress progress-extn" attr-translate-aria-label="PROGRESS_BAR_LABEL" aria-describedby="progressBarDescription">\n          <div ng-if="filterByStatusBar == undefined" aria-labelledby="idpendingPercent id_Pending" class="progress-bar progress-bar-pending pending-width progress-bar-focus" aria-describedby="notStartedButtonDescription"></div>\n          <div ng-if="filterByStatusBar != undefined" ng-click="statusBarFilter(\'pending\')" ng-class="{\'progress-bar-opacity\': (taskStatus !=undefined) && (taskStatus == \'ongoing\' || taskStatus == \'completed\')}" data-trigger="focus hover" aria-labelledby="{{(showPercent && pendingPercent ==100) ? \'idpendingPercent\':\'idpendingPercent id_Pending\'}}" class="progress-bar progress-bar-pending pending-width progress-bar-focus" bs-tooltip data-container="body" data-placement="bottom" data-title="{{pendingTooltip}}" aria-describedby="notStartedButtonDescription notStartedButtonTaskTooltip"></div>\n\n        </div>\n        <span id="notStartedButtonTaskTooltip" class="sr-only" ng-bind="pendingTooltip"></span>\n      </div>\n      <div class="progress-text">\n        <div id="idpendingPercent" title="{{pendingPercent}}{{\'PROGRESS_PERCENT_STATUS_NOTSTARTED\'|translate}}" class="progress-value" translate="PROGRESS_PERCENT_STATUS_NOTSTARTED" ng-class="{\'zero-progress\':pendingPercent ==0 || (taskStatus !=undefined) && (taskStatus == \'ongoing\' || taskStatus == \'completed\')}" translate-values="{percentValue: pendingPercent}" ng-if="showPercent"></div>\n      </div>\n    </div>\n  </div>\n</div>');
$templateCache.put('section/section_view.html','<div ng-if="!appliedListElement" class="section-view" ng-class="[panelClass, {\'expanded\': isCollapsed == false, \'collapsed\': isCollapsed}]" bs-collapse>\n  <div class="panel-heading">\n    <a href="" class="h2 panel-title" role="button" bs-collapse-toggle ng-click="$click()" ng-keyup="$keyUp($event)" ng-attr-aria-controls="{{panelId || undefined}}">\n      <i class="openIcon" ng-class="::headerToggleOpen"></i>\n      <span ng-if="isCollapsed" class="sr-only" translate="EXPAND_TEXT"></span>\n      <i class="closedIcon" ng-class="::headerToggleClosed"></i>\n      <span ng-if="!isCollapsed" class="sr-only" translate="COLLAPSE_TEXT"></span> {{::heading}}\n    </a>\n  </div>\n  <div class="panel-collapse" bs-collapse-target>\n    <div class="panel-body" ng-attr-id="{{panelId || undefined}}" ng-transclude ></div> \n  </div>\n</div>\n\n<li ng-if="appliedListElement" class="section-view" ng-class="[panelClass, {\'expanded\': isCollapsed == false, \'collapsed\': isCollapsed}]" bs-collapse>\n  <div class="panel-heading">\n    <a href="" class="h2 panel-title" role="button" bs-collapse-toggle ng-click="$click()" ng-keyup="$keyUp($event)" ng-attr-aria-controls="{{panelId || undefined}}">\n      <i class="openIcon" ng-class="::headerToggleOpen"></i>\n      <span ng-if="isCollapsed" class="sr-only" translate="EXPAND_TEXT"></span>\n      <i class="closedIcon" ng-class="::headerToggleClosed"></i>\n      <span ng-if="!isCollapsed" class="sr-only" translate="COLLAPSE_TEXT"></span> {{::heading}}\n    </a>\n  </div>\n  <div class="panel-collapse" bs-collapse-target> \n    <div class="panel-body" ng-attr-id="{{panelId || undefined}}" ng-transclude ></div>\n  </div>\n</li>\n');
$templateCache.put('sidepanel/sidepanel_view.html','<div ng-multi-transclude-controller>\n  <div ng-multi-transclude="testspot"></div>\n\n</div>\n\n\n');
$templateCache.put('slideout/slideout_view.html','<div ng-keyup="$slideout.escapeSlideout($event)">\n    <div class="slideout-backdrop" ng-cloak ng-class="{\'hideHeatShield\': $slideout.closed == true || $slideout.closed == false && $slideout.expand == false, \'slideout-displaytop\': !$slideout.showHeader}"></div>\n    <div class="sumt-slideout right" ng-class="$getSlideoutContainerClass($$slideout)" role="region" ng-hide="$$slideout.$closed && !$$slideout.$collapsed"\n        ng-attr-aria-labelledby="{{::$$slideout.$options.labelId || undefined}}" aria-label="{{$$slideout.$options.key === APP_SHELF_SLIDEOUT ? (\'SLIDEOUT_TXT\' | translate): (\'SLIDEOUT_CONFIGURATION_TXT\' | translate) }}" tabindex="-1">\n        <button id="btnCollapse" class="btn closeTab slideout-outline" ng-if="$$slideout.$options.showCollapse && !$$slideout.$collapsed" ng-click="$slideout.collapse($$slideout)" ng-attr-aria-describedby="{{::$$slideout.$options.labelId || undefined}}" ng-attr-aria-label="{{\'CLOSE_CONFIG_SLIDEOUT\' | translate}}"><i class="fa fa-chevron-right"></i></button>\n        <button id="btnExpand" class="btn closeTab collapsedTab slideout-outline" ng-if="$$slideout.$options.showCollapse && $$slideout.$collapsed" ng-click="$slideout.open($$slideout)" ng-attr-aria-describedby="{{::$$slideout.$options.labelId || undefined}}" ng-attr-aria-label="{{\'EXPAND_TEXT\' | translate}}"><i class="fa fa-chevron-left"></i></button>\n        <button class="btn closeTab slideout-outline" ng-if="::!$$slideout.$options.showCollapse" ng-click="$slideout.close()" ng-attr-aria-describedby="{{::$$slideout.$options.labelId || undefined}}" ng-attr-aria-label="{{\'CLOSE_TXT\' | translate}}"><i class="fa fa-times" aria-hidden="true"></i></button>\n        <div name="allcontent"></div>\n        <div ng-if="!$$slideout.$options.hasTemplate" ng-show="$$slideout.$options.showLeftSide "\n            class="slideout-left-container slideout-outline" aria-hidden="{{::!$$slideout.$options.showLeftSide}}">\n            <div class="slideout-inner-left">\n                <div name="headersection"></div>\n                <div name="sidecontent"></div>\n            </div>\n        </div>\n        <div ng-if="!$$slideout.$options.hasTemplate" ng-show="$$slideout.$expand" class="slideout-expanded-container"\n            ng-class="{\'no-left-content\': !$$slideout.$options.showLeftSide, \'arrow-padding\': $$slideout.$options.showLeftSide}">\n            <i class="fa fa-arrow-right" ng-click="$slideout.open($$slideout)" ng-show="$$slideout.$options.showLeftSide && $$slideout.$expand" ng-attr-aria-describedby="{{::$$slideout.$options.labelId || undefined}}"\n\t\t\t\tng-attr-aria-label="{{\'CLOSE_ADVANCED_EDIT\' | translate}}"></i>\n            <div name="expandcontent" aria-hidden="{{$$slideout.$closed}}"></div>\n            <div name="footer" aria-hidden="{{$$slideout.$closed}}"></div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('starRating/starRatingTemplate.html','<section class="ratingContainer displayInlineBlock" ng-if="ratingValue || fromSearch" ng-mouseover="!userRatingValue||userRating()" ng-mouseleave="!userRatingValue||averageRating()">\n  <span class="sr-only" ng-show="!screenReader">{{::\'RECOMMENDATION_RATING\' | translate}} {{ratingValue}} {{::\'ELIXHR_RATING_OUT_OF_5_TEXT\' | translate}}</span>\n  <span class="sr-only" ng-show="screenReader">{{screenreaderValue}}</span>\n  <i aria-hidden="true" class="fa" ng-class="{\'fa-star-o star-darkbackground\': ratingValue < 1 && colorValue == \'darkbackground\',\'fa-star-o star-outline\': ratingValue < 1 && colorValue != \'darkbackground\',\'fa-star star-yellow\':ratingValue >= 1,\'fa-star-half-full star-yellow\': ratingValue > 0 && ratingValue < 1 }"></i>\n  <i aria-hidden="true" class="fa" ng-class="{\'fa-star-o star-darkbackground\': ratingValue < 2 && colorValue == \'darkbackground\',\'fa-star-o star-outline\': ratingValue < 2 && colorValue != \'darkbackground\',\'fa-star star-yellow\':ratingValue >= 2,\'fa-star-half-full star-yellow\': ratingValue > 1 && ratingValue < 2 }" role="presentation"></i>\n  <i aria-hidden="true" class="fa" ng-class="{\'fa-star-o star-darkbackground\': ratingValue < 3 && colorValue == \'darkbackground\',\'fa-star-o star-outline\': ratingValue < 3 && colorValue != \'darkbackground\',\'fa-star star-yellow\':ratingValue >= 3,\'fa-star-half-full star-yellow\': ratingValue > 2 && ratingValue < 3 }" role="presentation"></i>\n  <i aria-hidden="true" class="fa" ng-class="{\'fa-star-o star-darkbackground\': ratingValue < 4 && colorValue == \'darkbackground\',\'fa-star-o star-outline\': ratingValue < 4 && colorValue != \'darkbackground\',\'fa-star star-yellow\':ratingValue >= 4,\'fa-star-half-full star-yellow\': ratingValue > 3 && ratingValue < 4 }" role="presentation"></i>\n  <i aria-hidden="true" class="fa" ng-class="{\'fa-star-o star-darkbackground\': ratingValue < 5 && colorValue == \'darkbackground\',\'fa-star-o star-outline\': ratingValue < 5 && colorValue != \'darkbackground\',\'fa-star star-yellow\':ratingValue >= 5,\'fa-star-half-full star-yellow\': ratingValue > 4 && ratingValue < 5 }" role="presentation"></i>\n</section>\n');
$templateCache.put('sumtprogressbar/sumtprogressbar.html','<div>\n  <div class="progress" aria-hidden="false">\n    <div class="progress-bar {{progressclass}}" ng-style="{\'width\': percentcomplete + \'%\'}">\n      <span ng-if="showProgessInline()" aria-live="assertive" ng-bind="(percentcomplete | number : 0) + \'%\'"></span>\n    </div>\n  </div>\n  <div ng-if="!showProgessInline()" class="progress-txt">\n    <span ng-bind="(percentcomplete | number : 0) + \'%\'" ></span>\n  </div>\n</div>\n');
$templateCache.put('timeline/timeline_view.html','<section>\n  <ul ng-show="filter == true" class="nav nav-pills nav-justified">\n    <li ng-repeat="tab in tabs" role="presentation" ng-class="{\'active\': tab == selectedTab, \'\': tab != selectedTab}"><a ng-click="setTabSelection(tab)">{{tab.filter}}</a></li>\n  </ul>\n  <div id="cd-timeline" class="cd-container" ng-class="{\'cd-timeline-stagger\': stagger === true}">\n    <div class="cd-timeline-block" ng-repeat="node in data track by $index">\n      <div class="cd-timeline-img cd-picture" ng-class="{\'cd-timeline-img-stagger\': stagger === true}">\n        <!--      <img ng-show="{{node.imageSource}}" ng-src="{{node.imageSource}}" alt="Picture">-->\n        <i class="fa fa-file"></i>\n      </div>\n      <div class="cd-timeline-content" ng-class="{\'cd-timeline-content-stagger\': stagger === true, \'cd-timeline-selected\': (highlight == \'true\' && compDate == node.date) || (node.highlight)}">\n        <h2>{{node.title}}</h2>\n        <p>{{node.body}}</p>\n        <button ng-href="{{node.readMore}}" class="btn btn-primary sumt-btn-primary cd-read-more" ng-show="{{node.readMore !== undefined}}">Read more</button>\n        <span class="cd-date">{{node.date | date:"MM/dd/yyyy"}}</span>\n      </div>\n    </div>\n  </div>\n</section>\n');
$templateCache.put('typeahead/typeaheadwrap.tpl.html','<ul id="typeahead_listbox" style="width:90%" class="typeahead dropdown-menu" ng-show="$isVisible()" role="listbox">\n\t<li style="width:94%;word-wrap: break-word;margin-left:10px;" role="option" ng-repeat="match in $matches | limitTo: 6" ng-class="{active: $index == $activeIndex}" >\n        <a style="display:list-item;white-space: pre-wrap;word-wrap: break-word;margin-left:10px;text-align: left;line-height:15px;"  ng-bind-template="{{match.label}}" ng-click="$select($index, $event)"></a>\n\t</li>\n\t<li ng-if="($matches.length > 6)" style="margin-left: 5px;word-wrap: break-word;background-color:#EEEEEE">\n\t\t<p style="text-align: center;word-wrap: break-word;margin-left:5px;Font-size:12px;">More jobs match your search. Try using more specific keywords to narrow the results</p>\n\t</li>\n</ul>\n');
$templateCache.put('webparts/webpartcontainer_view.html','<div class="sumt-webpartcontainer" ng-style="widthObj">\n  <h2 ng-hide="hideHeader" ng-model="headerclass" class="{{ headerClass }}">\n    <i class="{{ headerIcon }}" ng-show="headerIcon"></i>\n    {{headerTitle}}\n    <i ng-model="headerLinkIcon" class="{{ headerLinkIcon }}" ng-click="handleHeaderClick()" ng-show="headerLinkIcon" ng-style="headerStyleObj"></i>\n  </h2>\n  <div class="sumt-webpart-content" ng-style="heightObj" ng-class="contentClass">\n     <div ng-style="widthObj" ng-transclude ></div>\n  </div>\n</div>\n');
$templateCache.put('wizard/wizardsteps_view.html','<!-- <ol class="progTracker" role="presentation" ng-class="::{\'disabledStyle\':disabled===true}">\n  <li aria-selected="{{step.stepNum == activeStep}}" ng-repeat="step in ::stepArray" ng-class="step.stepNum < activeStep ? \'progTracker-done\' : step.stepNum == activeStep ? \'progTracker-active\' : disabled === true ? \'progTracker-disable\' : \'progTracker-todo\'">\n    <button type="button" ng-class="{\'activeStep stepline1 stepline1color\': step.stepNum == activeStep, \'stepline1 stepline2color inactiveStep\': step.stepNum != activeStep && step.stepNum != stepData[stepData.length-1].stepNum, \'lastStep\': step.stepNum == stepData[stepData.length-1].stepNum}"></button>\n\t   <p class="steptitle" ng-bind="::step.stepName"></p>\n\t</li>\n</ol> -->\n\n<ol class="progTracker" role="presentation" aria-label="{{translations.labelText}}">\n  <li ng-repeat="step in ::stepData">\n    <div class="step-line" \n          ng-class="\n            {\n              \'step-line-done\': step.stepNum < activeStep || step.stepCompleted, \n              \'step-line-todo\': step.stepNum >= activeStep && !step.stepCompleted, \n              \'step-line-disabled-completed\': (step.stepNum == activeStep && !step[step.stepNum-1].stepDisabled) || (step.stepCompleted && step.stepDisabled && step.stepNum > activeStep),\n              \'lastStep\': step.stepNum == stepData[stepData.length-1].stepNum\n            }">\n    </div>\n    <div class="step-node-container">\n      <div ng-if="step.stepNum == selectedStep" tabindex="0" style="display: inline-block;" class="step-node progTracker-active">\n        <span class="sr-only" ng-bind="step508Label(step)"></span>\n      </div>\n      <button \n        ng-click="goToStep(step)"\n        ng-keydown="($event.keyCode == 13 && goToStep(step)) || ($event.keyCode == 32 && goToStep(step))"\n        ng-if="step.stepNum != selectedStep"\n        aria-label="{{step508Label(step)}}"\n        ng-disabled="step.stepDisabled"\n        class="step-node"\n        type="button" \n        ng-class="\n          {\n            \'progTracker-done\' : step.stepCompleted, \n            \'progTracker-todo\' : !step.stepCompleted,\n            \'progTracker-done-disabled\' : step.stepCompleted && step.stepDisabled && step.stepNum > activeStep,\n            \'steps-open\': allStepsOpen\n          }">\n        <i aria-hidden="true" class="fa fa-check" ng-if="step.stepCompleted"></i>\n      </button> \n    </div>  \n    <div class="step-titles-container">\n      <div aria-hidden="true"\n      class="step-title" \n      ng-disabled="step.stepDisabled"\n      ng-class="\n        {\n          \'title-active\': step.stepNum == activeStep && step.stepNum == selectedStep, \n          \'title-selected\': step.stepNum == selectedStep\n        }"\n      ng-bind="::step.stepName">\n      </div>\n     <div aria-hidden="true" \n        class="step-title"\n        ng-disabled="step.stepDisabled" \n        ng-class="\n          {\n            \'title-active\': step.stepNum == activeStep && step.stepNum == selectedStep, \n            \'title-selected\': step.stepNum == selectedStep\n          }"\n        ng-bind="::step.stepSubName">\n        </div>\n     <span ng-if="step.instructionText!=\'\'" class="instruction-Text">{{::step.instructionText}}</span>\n    </div>       \n\t</li>\n</ol>\n');}]);
angular.module('SumTotalComponents')
  .constant('FOUNDATION_TRANSLATIONS', {
    en: {
      CLOSE: 'Close',
      CLOSE_TXT: 'Close'
    },
    de: {
      CLOSE: 'Nah dran',
      CLOSE_TXT: 'Schließen'
    },
    arSA: {
      CLOSE_TXT: 'إغلاق'
    },
    cs: {
      CLOSE_TXT: 'Zavřít'
    },
    da: {
      CLOSE_TXT: 'Luk'
    },
    el: {
      CLOSE_TXT: 'Κλείσιμο'
    },
    enGB: {
      CLOSE_TXT: 'Close'
    },
    esMX: {
      CLOSE_TXT: 'Cerrar'
    },
    es: {
      CLOSE_TXT: 'Cerrar'
    },
    fi: {
      CLOSE_TXT: 'Sulje'
    },
    frCA: {
      CLOSE_TXT: 'Fermer'
    },
    fr: {
      CLOSE_TXT: 'Fermer'
    },
    hu: {
      CLOSE_TXT: 'Bezárás'
    },
    id: {
      CLOSE_TXT: 'Tutup'
    },
    it: {
      CLOSE_TXT: 'Chiudi'
    },
    ja: {
      CLOSE_TXT: '閉じる'
    },
    ko: {
      CLOSE_TXT: '닫기'
    },
    nl: {
      CLOSE_TXT: 'Sluiten'
    },
    no: {
      CLOSE_TXT: 'Lukk'
    },
    pl: {
      CLOSE_TXT: 'Zamknij'
    },
    ptBR: {
      CLOSE_TXT: 'Fechar'
    },
    ro: {
      CLOSE_TXT: 'Închidere'
    },
    ru: {
      CLOSE_TXT: 'Закрыть'
    },
    sl: {
      CLOSE_TXT: 'Zapri'
    },
    sv: {
      CLOSE_TXT: 'Stäng'
    },
    th: {
      CLOSE_TXT: 'ปิด'
    },
    tr: {
      CLOSE_TXT: 'Kapat'
    },
    uk: {
      CLOSE_TXT: 'Закрити'
    },
    vi: {
      CLOSE_TXT: 'Đóng'
    },
    zhHans: {
      CLOSE_TXT: '关闭'
    },
    zhHant: {
      CLOSE_TXT: '關閉'
    }
  });

angular.module('SumTotalComponents').config(['FOUNDATION_TRANSLATIONS', '$translateProvider', '$alertProvider', '$modalProvider',
  function (translations, $translateProvider, $alertProvider, $modalProvider) {

    $translateProvider
      .translations('en', translations.en)
      .translations('de', translations.de)
      .translations('ar-SA', translations.arSA)
      .translations('cs', translations.cs)
      .translations('da', translations.da)
      .translations('el', translations.el)
      .translations('en-GB', translations.enGB)
      .translations('es-MX', translations.esMX)
      .translations('es', translations.es)
      .translations('fi', translations.fi)
      .translations('fr-CA', translations.frCA)
      .translations('fr', translations.fr)
      .translations('hu', translations.hu)
      .translations('id', translations.id)
      .translations('it', translations.it)
      .translations('ja', translations.ja)
      .translations('ko', translations.ko)
      .translations('nl', translations.nl)
      .translations('no', translations.no)
      .translations('pl', translations.pl)
      .translations('pt-BR', translations.ptBR)
      .translations('ro', translations.ro)
      .translations('ru', translations.ru)
      .translations('sl', translations.sl)
      .translations('sv', translations.sv)
      .translations('th', translations.th)
      .translations('tr', translations.tr)
      .translations('uk', translations.uk)
      .translations('vi', translations.vi)
      .translations('zh-Hans', translations.zhHans)
      .translations('zh-Hant', translations.zhHant)
      .preferredLanguage('en');

    // set the default template for the alert to be our 508 compliant one.
    angular.extend($alertProvider.defaults, {
      templateUrl: 'angular-strap/alert.html'
    });

    angular.extend($modalProvider.defaults, {
      backdrop: 'static'
    });
  }]);
